


// import React, { useState, useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';
// import config from '../../Common/Configurations/APIConfig';
// import apiService from "../../Common/Configurations/APIService";
// import Header from '../../Common/Layout/Header';
// import { useAuth } from '../../Common/Configurations/AuthContext';
// import moment from 'moment';
// import { Button, Form, Row, Col, Card, Badge, InputGroup, Modal, Spinner, Tab, Tabs } from 'react-bootstrap';
// import { toast } from 'react-toastify';
// import DefaultData from '../../CompanyData/DefaultData';

// // --- ENHANCED STYLES ---
// const styles = {
//     pageBg: { backgroundColor: "#f3f4f6", minHeight: "100vh" },
//     summaryStrip: {
//         background: "#ffffff",
//         color: "#212529",
//         borderRadius: "0px",
//         borderBottom: "1px solid #e9ebec"
//     },
//     gridLabel: {
//         color: "#878a99",
//         fontSize: "10px",
//         textTransform: "uppercase",
//         fontWeight: "700",
//         letterSpacing: "0.5px"
//     },
//     gridValue: {
//         color: "#212529",
//         fontWeight: "600",
//         fontSize: "13px"
//     },
// };

// const leadStatusOptions = [
//     "NEW", "FOLLOW UP", "REPLIED", "NOT RESPONDING", 
//     "NOT WORKING", "CLOSED", "PROCESSING", "WON", "LOST"
// ];

// const getStatusColor = (status) => {
//     switch (status) {
//         case 'NEW': return '#f06548';
//         case 'PROCESSING': return '#f7b84b';
//         case 'WON': return '#0ab39c';
//         case 'LOST': return '#212529';
//         case 'FOLLOW UP': return '#f7b84b';
//         case 'CLOSED': return '#0ab39c';
//         default: return '#405189';
//     }
// };

// const getLeadStatusBadge = (status) => {
//     const name = status?.toLowerCase();
//     if (name?.includes('new')) return 'badge bg-primary text-white';
//     if (name?.includes('follow up')) return 'badge bg-warning text-white';
//     if (name?.includes('replied')) return 'badge bg-secondary text-white';
//     if (name?.includes('not responding')) return 'badge bg-danger text-white';
//     if (name?.includes('not working')) return 'badge bg-info text-white';
//     if (name?.includes('closed')) return 'badge bg-success text-white';
//     if (name?.includes('processing')) return 'badge bg-info text-white';
//     if (name?.includes('won')) return 'badge bg-success text-white';
//     if (name?.includes('lost')) return 'badge bg-danger text-white';
//     return 'badge bg-light text-dark';
// };

// // ============================================
// // DMC CHAT COMPONENT - Complete with All Functions (No Limits)
// // ============================================
// const DmcChatView = ({ chatId, leadId, onClose, onMessageSent }) => {
//     const [chat, setChat] = useState(null);
//     const [messages, setMessages] = useState([]);
//     const [newMessage, setNewMessage] = useState('');
//     const [isLoading, setIsLoading] = useState(true);
//     const [isSending, setIsSending] = useState(false);
//     const [selectedFiles, setSelectedFiles] = useState([]);
//     const [refreshKey, setRefreshKey] = useState(0);
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const messagesEndRef = useRef(null);
//     const fileInputRef = useRef(null);
//     const { user } = useAuth();

//     useEffect(() => {
//         if (chatId) {
//             fetchChat();
//         }
//     }, [chatId, refreshKey]);

//     useEffect(() => {
//         scrollToBottom();
//     }, [messages]);

//     const fetchChat = async () => {
//         try {
//             setIsLoading(true);
//             const response = await apiService.get(`${config.GET_DMC_CHAT_BY_ID}/${chatId}`);
//             console.log('Fetched chat response:', response);
            
//             if (response && response.data) {
//                 setChat(response.data);
//                 const msgs = response.data.messages || [];
//                 setMessages(msgs);
//                 await markMessagesAsRead(msgs);
//             } else {
//                 console.error('No chat data received');
//             }
//         } catch (error) {
//             console.error('Error fetching chat:', error);
//             toast.error('Failed to load chat');
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const markMessagesAsRead = async (msgs) => {
//         const currentUserId = user?.id || 'current-user-id';
//         const unreadMessages = msgs.filter(m => 
//             !m.isRead && m.senderType !== 'STAFF'
//         );
        
//         for (const msg of unreadMessages) {
//             try {
//                 await apiService.put(config.MARK_DMC_MESSAGE_READ, {
//                     chatId: chatId,
//                     messageId: msg.messageId,
//                     readerId: currentUserId
//                 });
//             } catch (err) {
//                 console.error('Error marking message as read:', err);
//             }
//         }
//     };

//     // ============================================
//     // SEND MESSAGE WITH FILES - Using postWithFile
//     // ============================================
//     const sendMessage = async () => {
//         if (!newMessage.trim() && selectedFiles.length === 0) {
//             toast.warning('Please enter a message or attach a file');
//             return;
//         }

//         try {
//             setIsSending(true);
//             setUploadProgress(0);
            
//             const formData = new FormData();
//             formData.append('chatId', chatId);
//             formData.append('content', newMessage.trim() || 'Shared file(s)');
//             formData.append('senderId', user?.id || 'current-user-id');
//             formData.append('senderName', user?.name || 'You');
//             formData.append('senderType', 'STAFF');
//             formData.append('senderCompanyName', DefaultData.DEFAULTCOMPANYNAME);

//             // Append all files without any limits
//             if (selectedFiles.length > 0) {
//                 selectedFiles.forEach((file, index) => {
//                     formData.append('attachments', file, file.name);
//                 });
//             }

//             console.log('Sending message with files:', selectedFiles.length);

//             // Use existing postWithFile method from apiService
//             const response = await apiService.postWithFile(
//                 config.SEND_DMC_CHAT_MESSAGE, 
//                 formData,
//                 true // showToast
//             );

//             console.log('Send message response:', response);

//             if (response) {
//                 // Check if response has success or data
//                 if (response.success !== false) {
//                     if (response.data) {
//                         setMessages(prev => [...prev, response.data]);
//                     }
//                     setNewMessage('');
//                     setSelectedFiles([]);
//                     setUploadProgress(0);
//                     if (fileInputRef.current) {
//                         fileInputRef.current.value = '';
//                     }
//                     if (onMessageSent) {
//                         onMessageSent();
//                     }
//                     setRefreshKey(prev => prev + 1);
//                     // toast.success already handled by postWithFile
//                 } else {
//                     toast.error(response?.message || 'Failed to send message');
//                 }
//             }
//         } catch (error) {
//             console.error('Error sending message:', error);
//             // Error toast already handled by apiService
//         } finally {
//             setIsSending(false);
//             setUploadProgress(0);
//         }
//     };

//     // ============================================
//     // FILE SELECTION HANDLER - No Limits
//     // ============================================
//     const handleFileSelect = (e) => {
//         const files = Array.from(e.target.files);
//         if (files.length === 0) return;
        
//         // No size limits, no type restrictions - accept all files
//         setSelectedFiles(prev => [...prev, ...files]);
//         toast.success(`${files.length} file(s) selected`);
//     };

//     const removeFile = (index) => {
//         setSelectedFiles(prev => prev.filter((_, i) => i !== index));
//         if (fileInputRef.current) {
//             fileInputRef.current.value = '';
//         }
//     };

//     const scrollToBottom = () => {
//         setTimeout(() => {
//             messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//         }, 100);
//     };

//     // ============================================
//     // RENDER ENQUIRY DETAILS
//     // ============================================
//     const renderEnquiryDetails = (enquiryDetails) => {
//         if (!enquiryDetails) return null;
        
//         const details = enquiryDetails.serviceDetails || {};
//         const entries = Object.entries(details);
        
//         const requirementsText = enquiryDetails.requirements || enquiryDetails.Requirements || '';
        
//         if (entries.length === 0 && !requirementsText) return null;
        
//         const displayOrder = [
//             'enquiryType', 'packageName', 'packageDestination', 'destination',
//             'travelDate', 'startDate', 'returnDate',
//             'adults', 'kids', 'infant', 'totalGuests', 'travelers',
//             'packageDuration', 'duration', 'noOfDays',
//             'packageType', 'packagePreference'
//         ];
        
//         const sortedEntries = [...entries].sort((a, b) => {
//             const indexA = displayOrder.findIndex(key => a[0].toLowerCase().includes(key.toLowerCase()));
//             const indexB = displayOrder.findIndex(key => b[0].toLowerCase().includes(key.toLowerCase()));
//             if (indexA === -1 && indexB === -1) return 0;
//             if (indexA === -1) return 1;
//             if (indexB === -1) return -1;
//             return indexA - indexB;
//         });
        
//         return (
//             <div className="enquiry-details-container mb-2 p-3 rounded-3" style={{ 
//                 backgroundColor: '#f0f7ff', 
//                 border: '1px solid #cfe2ff',
//                 borderRadius: '12px'
//             }}>
//                 <div className="d-flex align-items-center mb-2">
//                     <i className="ri-file-list-3-line text-primary me-2" style={{ fontSize: '18px' }}></i>
//                     <span className="fw-bold text-primary" style={{ fontSize: '13px' }}>📋 Enquiry Details</span>
//                 </div>
                
//                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2px 16px' }}>
//                     {sortedEntries.map(([key, value]) => {
//                         if (key.toLowerCase().includes('price') || 
//                             key.toLowerCase().includes('cost') || 
//                             key.toLowerCase().includes('amount') ||
//                             key.toLowerCase().includes('total')) {
//                             return null;
//                         }
                        
//                         if (key.toLowerCase().includes('requirements') || 
//                             key.toLowerCase().includes('specialrequests') ||
//                             key.toLowerCase().includes('description')) {
//                             return null;
//                         }
                        
//                         if (key.toLowerCase().includes('reference') || 
//                             (key.toLowerCase().includes('id') && !key.toLowerCase().includes('package'))) {
//                             return null;
//                         }
                        
//                         let displayKey = key
//                             .replace(/([A-Z])/g, ' $1')
//                             .replace(/^./, str => str.toUpperCase())
//                             .replace(/Package/g, '')
//                             .trim();
                        
//                         if (!displayKey) displayKey = key;
                        
//                         let displayValue = value?.toString() || 'N/A';
                        
//                         if (key.toLowerCase().includes('date') || key.toLowerCase().includes('travel')) {
//                             if (displayValue !== 'N/A' && displayValue !== '') {
//                                 try {
//                                     const date = moment(displayValue);
//                                     if (date.isValid()) {
//                                         displayValue = date.format('DD MMM YYYY');
//                                     }
//                                 } catch (e) {}
//                             }
//                         }
                        
//                         if (key.toLowerCase().includes('adults') || 
//                             key.toLowerCase().includes('kids') || 
//                             key.toLowerCase().includes('infant') ||
//                             key.toLowerCase().includes('guests') ||
//                             key.toLowerCase().includes('travelers')) {
//                             if (displayValue !== 'N/A' && !isNaN(displayValue)) {
//                                 displayValue = `👤 ${displayValue}`;
//                             }
//                         }
                        
//                         if (displayValue === '' || displayValue === 'N/A' || displayValue === 'Not specified') {
//                             return null;
//                         }
                        
//                         return (
//                             <div key={key} className="d-flex align-items-center py-1" style={{ borderBottom: '1px solid rgba(0,0,0,0.04)' }}>
//                                 <span style={{ 
//                                     fontSize: '11px', 
//                                     fontWeight: '500',
//                                     color: '#6c757d',
//                                     minWidth: '100px',
//                                     flexShrink: 0
//                                 }}>
//                                     {displayKey}:
//                                 </span>
//                                 <span style={{ 
//                                     fontSize: '12px', 
//                                     fontWeight: '500',
//                                     color: '#212529',
//                                     wordBreak: 'break-word'
//                                 }}>
//                                     {displayValue}
//                                 </span>
//                             </div>
//                         );
//                     })}
//                 </div>
                
//                 {requirementsText && requirementsText !== 'N/A' && (
//                     <div className="mt-2 pt-2" style={{ borderTop: '1px solid rgba(0,0,0,0.08)' }}>
//                         <div className="d-flex align-items-start">
//                             <i className="ri-question-answer-line text-warning me-2 mt-1" style={{ fontSize: '16px' }}></i>
//                             <div style={{ flex: 1 }}>
//                                 <span style={{ fontSize: '11px', fontWeight: '600', color: '#6c757d' }}>Requirements:</span>
//                                 <p className="mb-0 mt-1" style={{ 
//                                     fontSize: '13px', 
//                                     fontWeight: '500',
//                                     color: '#212529',
//                                     lineHeight: '1.6',
//                                     wordBreak: 'break-word'
//                                 }}>
//                                     {requirementsText}
//                                 </p>
//                             </div>
//                         </div>
//                     </div>
//                 )}
                
//                 {sortedEntries.filter(([key, value]) => {
//                     const lowerKey = key.toLowerCase();
//                     const displayValue = value?.toString() || '';
//                     return !lowerKey.includes('price') && 
//                            !lowerKey.includes('cost') && 
//                            !lowerKey.includes('amount') &&
//                            !lowerKey.includes('total') &&
//                            !lowerKey.includes('reference') &&
//                            !(lowerKey.includes('id') && !lowerKey.includes('package')) &&
//                            !lowerKey.includes('requirements') &&
//                            !lowerKey.includes('specialrequests') &&
//                            !lowerKey.includes('description') &&
//                            displayValue !== '' &&
//                            displayValue !== 'N/A' &&
//                            displayValue !== 'Not specified';
//                 }).length === 0 && !requirementsText && (
//                     <div className="text-muted text-center py-2" style={{ fontSize: '12px' }}>
//                         No enquiry details available
//                     </div>
//                 )}
//             </div>
//         );
//     };

//     // ============================================
//     // RENDER MESSAGE CONTENT
//     // ============================================
//     const renderMessageContent = (content, isStaff) => {
//         if (!content) return null;
        
//         const enquiryMarkers = [
//             '📋 New Enquiry Notification',
//             '━━━━━━━━━━━━━━━━━━━━━━━━━',
//             '📌 Enquiry Type:',
//             '🏢 COMPANY DETAILS',
//             '👤 STAFF CONTACT'
//         ];
        
//         const hasEnquiryMarkers = enquiryMarkers.some(marker => content.includes(marker));
        
//         if (hasEnquiryMarkers) {
//             const lines = content.split('\n');
//             const messageLines = [];
//             let foundMessage = false;
            
//             for (const line of lines) {
//                 if (line.includes('💬 Please review') || line.includes('Thank you!')) {
//                     foundMessage = true;
//                 }
                
//                 if (foundMessage && line.trim()) {
//                     messageLines.push(line);
//                 }
//             }
            
//             if (messageLines.length === 0) {
//                 const textLines = lines.filter(line => 
//                     !enquiryMarkers.some(marker => line.includes(marker)) &&
//                     !line.includes('━━━━━━━━━━━━━━━━━━━━━━━━━') &&
//                     !line.includes('Company:') &&
//                     !line.includes('Brand:') &&
//                     !line.includes('Email:') &&
//                     !line.includes('Phone:') &&
//                     !line.includes('Staff:') &&
//                     !line.includes('Name:') &&
//                     !line.includes('📌') &&
//                     !line.includes('🆔') &&
//                     !line.includes('🏢') &&
//                     !line.includes('👤') &&
//                     line.trim()
//                 );
                
//                 if (textLines.length > 0) {
//                     const fullText = textLines.join('\n');
//                     if (fullText.includes('Package enquiry for') || 
//                         fullText.includes('Requirements:')) {
//                         return null;
//                     }
                    
//                     return (
//                         <div className="message-content" style={{ 
//                             fontSize: '13px', 
//                             lineHeight: '1.6',
//                             whiteSpace: 'pre-wrap',
//                             wordBreak: 'break-word'
//                         }}>
//                             {fullText}
//                         </div>
//                     );
//                 }
                
//                 return null;
//             }
            
//             const messageText = messageLines.join('\n');
//             if (messageText.includes('Please review') && messageText.includes('Thank you')) {
//                 return (
//                     <div className="message-content" style={{ 
//                         fontSize: '13px', 
//                         lineHeight: '1.6',
//                         whiteSpace: 'pre-wrap',
//                         wordBreak: 'break-word',
//                         fontStyle: 'italic',
//                         color: '#6c757d'
//                     }}>
//                         {messageText}
//                     </div>
//                 );
//             }
            
//             return (
//                 <div className="message-content" style={{ 
//                     fontSize: '13px', 
//                     lineHeight: '1.6',
//                     whiteSpace: 'pre-wrap',
//                     wordBreak: 'break-word'
//                 }}>
//                     {messageText}
//                 </div>
//             );
//         }
        
//         return (
//             <div className="message-content" style={{ 
//                 fontSize: '13px', 
//                 lineHeight: '1.6',
//                 whiteSpace: 'pre-wrap',
//                 wordBreak: 'break-word'
//             }}>
//                 {content}
//             </div>
//         );
//     };

//     // ============================================
//     // RENDER FILE ATTACHMENT
//     // ============================================
//     const renderFileAttachment = (file, isStaff) => {
//         if (!file) return null;
        
//         const isImage = file.fileType?.startsWith('image/') || 
//                        file.fileName?.match(/\.(jpg|jpeg|png|gif|webp|svg|bmp|ico|tiff|tif)$/i);
        
//         const isVideo = file.fileType?.startsWith('video/') || 
//                        file.fileName?.match(/\.(mp4|avi|mov|wmv|flv|mkv|webm|3gp)$/i);
        
//         const isAudio = file.fileType?.startsWith('audio/') || 
//                        file.fileName?.match(/\.(mp3|wav|aac|flac|ogg|wma)$/i);
        
//         const isDocument = file.fileName?.match(/\.(pdf|doc|docx|xls|xlsx|ppt|pptx|txt|csv|rtf|odt)$/i);
        
//         return (
//             <div className="d-flex align-items-center mt-1">
//                 {isImage ? (
//                     <a href={file.fileUrl} target="_blank" rel="noopener noreferrer" className="d-block">
//                         <img 
//                             src={file.fileUrl} 
//                             alt={file.fileName}
//                             style={{ 
//                                 maxWidth: '200px', 
//                                 maxHeight: '150px', 
//                                 borderRadius: '8px',
//                                 border: '1px solid #dee2e6',
//                                 objectFit: 'cover'
//                             }}
//                             onError={(e) => {
//                                 e.target.style.display = 'none';
//                             }}
//                         />
//                     </a>
//                 ) : isVideo ? (
//                     <video 
//                         controls 
//                         style={{ 
//                             maxWidth: '250px', 
//                             maxHeight: '200px', 
//                             borderRadius: '8px',
//                             border: '1px solid #dee2e6'
//                         }}
//                     >
//                         <source src={file.fileUrl} />
//                         Your browser does not support the video tag.
//                     </video>
//                 ) : isAudio ? (
//                     <audio controls style={{ maxWidth: '250px' }}>
//                         <source src={file.fileUrl} />
//                         Your browser does not support the audio tag.
//                     </audio>
//                 ) : (
//                     <a 
//                         href={file.fileUrl} 
//                         target="_blank" 
//                         rel="noopener noreferrer" 
//                         className={`d-flex align-items-center small ${isStaff ? 'text-white-50' : 'text-primary'}`}
//                         style={{ fontSize: '11px', textDecoration: 'none' }}
//                     >
//                         {isDocument ? (
//                             <i className="ri-file-text-line me-1"></i>
//                         ) : (
//                             <i className="ri-file-line me-1"></i>
//                         )}
//                         📎 {file.fileName} ({(file.fileSizeKb || 0).toFixed(1)} KB)
//                     </a>
//                 )}
//             </div>
//         );
//     };

//     // ============================================
//     // RENDER MESSAGE
//     // ============================================
//     const renderMessage = (msg, index) => {
//         const isStaff = msg.senderType === 'STAFF';
//         const isEnquiryDetails = msg.messageType === 'ENQUIRY_DETAILS';

//         return (
//             <div key={index} className={`d-flex mb-3 ${isStaff ? 'justify-content-end' : 'justify-content-start'}`}>
//                 <div className={`p-3 rounded-3 ${isStaff ? 'bg-primary text-white' : 'bg-white shadow-sm border'}`} style={{ maxWidth: '85%', minWidth: '200px' }}>
//                     {/* Sender Info */}
//                     <div className="d-flex justify-content-between align-items-center mb-2">
//                         <small className={`fw-bold ${isStaff ? 'text-white' : 'text-dark'}`} style={{ fontSize: '12px' }}>
//                             {isStaff ? 'You' : (msg.senderName || chat?.dmcCompanyName)}
//                         </small>
//                         <small className={`ms-2 ${isStaff ? 'text-white-50' : 'text-muted'}`} style={{ fontSize: '10px' }}>
//                             {moment(msg.sentAt).format('DD MMM, HH:mm')}
//                         </small>
//                     </div>

//                     {/* Enquiry Details */}
//                     {isEnquiryDetails && msg.enquiryDetails && (
//                         <div className="mb-2">
//                             {renderEnquiryDetails(msg.enquiryDetails)}
//                             {msg.content && (
//                                 <div className="mt-2 pt-2" style={{ borderTop: '1px solid rgba(0,0,0,0.08)' }}>
//                                     <div className="d-flex align-items-center mb-1">
//                                         <i className="ri-chat-2-line text-muted me-1" style={{ fontSize: '12px' }}></i>
//                                         <span style={{ fontSize: '11px', fontWeight: '500', color: '#6c757d' }}>Message:</span>
//                                     </div>
//                                     {renderMessageContent(msg.content, isStaff)}
//                                 </div>
//                             )}
//                         </div>
//                     )}

//                     {/* Regular Message Content */}
//                     {!isEnquiryDetails && msg.content && (
//                         <div className="mb-1" style={{ fontSize: '13px', wordBreak: 'break-word', lineHeight: '1.6' }}>
//                             {msg.content}
//                         </div>
//                     )}

//                     {/* Attachments - Show all types */}
//                     {msg.attachments && msg.attachments.length > 0 && (
//                         <div className="mt-2">
//                             {msg.attachments.map((file, idx) => (
//                                 <div key={idx} className="mb-1">
//                                     {renderFileAttachment(file, isStaff)}
//                                 </div>
//                             ))}
//                         </div>
//                     )}

//                     {/* Read Receipt */}
//                     {msg.isRead && isStaff && (
//                         <small className="text-white-50 d-block mt-1" style={{ fontSize: '9px' }}>
//                             <i className="ri-check-double-line me-1"></i> Read
//                         </small>
//                     )}
//                 </div>
//             </div>
//         );
//     };

//     if (isLoading) {
//         return (
//             <div className="d-flex justify-content-center align-items-center p-5" style={{ height: '100%' }}>
//                 <Spinner animation="border" variant="primary" />
//                 <span className="ms-2 text-muted small">Loading chat...</span>
//             </div>
//         );
//     }

//     if (!chat) {
//         return (
//             <div className="d-flex justify-content-center align-items-center p-5" style={{ height: '100%' }}>
//                 <p className="text-muted">Chat not found</p>
//             </div>
//         );
//     }

//     return (
//         <div className="dmc-chat-container bg-white" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
//             {/* Chat Header */}
//             <div className="p-2 border-bottom bg-light d-flex justify-content-between align-items-center" style={{ flexShrink: 0 }}>
//                 <div>
//                     <h6 className="mb-0 fw-bold" style={{ fontSize: '13px' }}>
//                         <i className="ri-chat-3-line me-2 text-primary"></i>
//                         {chat.dmcCompanyName || 'DMC Chat'}
//                     </h6>
//                     <small className="text-muted" style={{ fontSize: '10px' }}>
//                         Enquiry: {chat.enquiryType || 'Package'} • 
//                         Status: <Badge bg={chat.status === 'ACTIVE' ? 'success' : 'secondary'} style={{ fontSize: '8px' }}>
//                             {chat.status || 'ACTIVE'}
//                         </Badge>
//                     </small>
//                 </div>
//                 <div>
//                     <Button variant="link" size="sm" className="text-danger p-0" onClick={onClose}>
//                         <i className="ri-close-line fs-18"></i>
//                     </Button>
//                 </div>
//             </div>

//             {/* Company Info Banner */}
//             <div className="p-1 px-2 bg-light border-bottom" style={{ flexShrink: 0 }}>
//                 <small className="text-muted" style={{ fontSize: '9px' }}>
//                     <i className="ri-building-line me-1"></i>
//                     <strong>Your Company:</strong> {chat.userCompanyName || DefaultData.DEFAULTCOMPANYNAME}
//                 </small>
//                 <small className="text-muted ms-2" style={{ fontSize: '9px' }}>
//                     <i className="ri-mail-line me-1"></i>
//                     {chat.userEmail || DefaultData.DEFAULTCOMPANYEMAIL}
//                 </small>
//                 <small className="text-muted ms-2" style={{ fontSize: '9px' }}>
//                     <i className="ri-phone-line me-1"></i>
//                     +{chat.userPhoneNumber || DefaultData.DEFAULTCOMPANYPHONENUMBER}
//                 </small>
//             </div>

//             {/* Messages Area */}
//             <div className="p-2 overflow-auto flex-grow-1" style={{ flex: 1, minHeight: 0, backgroundColor: '#f8f9fa' }}>
//                 {messages.length === 0 ? (
//                     <div className="text-center text-muted py-4">
//                         <i className="ri-chat-smile-3-line fs-36"></i>
//                         <p className="mt-2" style={{ fontSize: '13px' }}>No messages yet. Start the conversation!</p>
//                     </div>
//                 ) : (
//                     messages.map((msg, index) => renderMessage(msg, index))
//                 )}
//                 <div ref={messagesEndRef} />
//             </div>

//             {/* Message Input */}
//             <div className="border-top p-2 bg-white" style={{ flexShrink: 0 }}>
//                 {selectedFiles.length > 0 && (
//                     <div className="mb-1 d-flex flex-wrap gap-1">
//                         {selectedFiles.map((file, index) => (
//                             <Badge key={index} bg="light" text="dark" className="border p-1 d-flex align-items-center" style={{ fontSize: '10px' }}>
//                                 {file.type?.startsWith('image/') ? (
//                                     <i className="ri-image-line me-1"></i>
//                                 ) : file.type?.startsWith('video/') ? (
//                                     <i className="ri-video-line me-1"></i>
//                                 ) : file.type?.startsWith('audio/') ? (
//                                     <i className="ri-music-line me-1"></i>
//                                 ) : (
//                                     <i className="ri-file-line me-1"></i>
//                                 )}
//                                 {file.name} ({(file.size / 1024).toFixed(1)} KB)
//                                 <Button 
//                                     variant="link" 
//                                     size="sm" 
//                                     className="p-0 ms-1 text-danger"
//                                     onClick={() => removeFile(index)}
//                                     style={{ fontSize: '10px', lineHeight: 1 }}
//                                 >
//                                     <i className="ri-close-line"></i>
//                                 </Button>
//                             </Badge>
//                         ))}
//                     </div>
//                 )}

//                 {uploadProgress > 0 && uploadProgress < 100 && (
//                     <div className="mb-1">
//                         <div className="d-flex align-items-center">
//                             <small className="text-muted me-2" style={{ fontSize: '10px' }}>
//                                 Uploading... {uploadProgress}%
//                             </small>
//                             <div className="flex-grow-1" style={{ height: '4px', backgroundColor: '#e9ecef', borderRadius: '2px' }}>
//                                 <div 
//                                     style={{ 
//                                         width: `${uploadProgress}%`, 
//                                         height: '100%', 
//                                         backgroundColor: '#0d6efd', 
//                                         borderRadius: '2px',
//                                         transition: 'width 0.3s ease'
//                                     }}
//                                 />
//                             </div>
//                         </div>
//                     </div>
//                 )}

//                 <div className="d-flex gap-1">
//                     <input
//                         type="file"
//                         ref={fileInputRef}
//                         onChange={handleFileSelect}
//                         multiple
//                         style={{ display: 'none' }}
//                     />
//                     <Button 
//                         variant="outline-secondary" 
//                         size="sm"
//                         onClick={() => fileInputRef.current?.click()}
//                         disabled={isSending || chat.status !== 'ACTIVE'}
//                         style={{ padding: '4px 8px' }}
//                         title="Attach files"
//                     >
//                         <i className="ri-attachment-2"></i>
//                     </Button>
//                     <Form.Control
//                         size="sm"
//                         value={newMessage}
//                         onChange={(e) => setNewMessage(e.target.value)}
//                         onKeyPress={(e) => e.key === 'Enter' && !e.shiftKey && sendMessage()}
//                         placeholder="Type your message..."
//                         disabled={isSending || chat.status !== 'ACTIVE'}
//                         style={{ fontSize: '13px' }}
//                     />
//                     <Button 
//                         variant="primary" 
//                         size="sm"
//                         onClick={sendMessage} 
//                         disabled={isSending || (!newMessage.trim() && selectedFiles.length === 0)}
//                         style={{ padding: '4px 12px' }}
//                     >
//                         {isSending ? <Spinner size="sm" animation="border" /> : <i className="ri-send-plane-line"></i>}
//                     </Button>
//                 </div>
//             </div>
//         </div>
//     );
// };
// // ============================================
// // DMC SELECTION MODAL
// // ============================================
// const DmcSelectionModal = ({ show, onHide, onSelectDmcs }) => {
//     const [dmcs, setDmcs] = useState([]);
//     const [filteredDmcs, setFilteredDmcs] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDmcs, setSelectedDmcs] = useState([]);

//     const parentCompanyId = DefaultData.DEFAULTCOMPANYID;

//     useEffect(() => {
//         if (show) fetchDmcs();
//     }, [show]);

//     useEffect(() => {
//         filterDmcs();
//     }, [searchTerm, dmcs]);

//     const fetchDmcs = async () => {
//         setIsLoading(true);
//         try {
//             const url = `${config.GETDMCS}/${parentCompanyId}`;
//             const response = await apiService.getAll(url);
//             if (response && response.data) {
//                 setDmcs(response.data);
//                 setFilteredDmcs(response.data);
//             }
//         } catch (error) {
//             console.error("Error fetching DMCs:", error);
//             toast.error("Failed to load DMCs");
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const filterDmcs = () => {
//         if (!searchTerm.trim()) {
//             setFilteredDmcs(dmcs);
//             return;
//         }
//         const lowerSearch = searchTerm.toLowerCase();
//         const filtered = dmcs.filter(dmc =>
//             (dmc.companyName && dmc.companyName.toLowerCase().includes(lowerSearch)) ||
//             (dmc.brandName && dmc.brandName.toLowerCase().includes(lowerSearch)) ||
//             (dmc.destinations && dmc.destinations.toLowerCase().includes(lowerSearch)) ||
//             (dmc.city && dmc.city.toLowerCase().includes(lowerSearch)) ||
//             (dmc.country && dmc.country.toLowerCase().includes(lowerSearch))
//         );
//         setFilteredDmcs(filtered);
//     };

//     const toggleDmcSelection = (dmc) => {
//         setSelectedDmcs(prev => {
//             const exists = prev.find(d => d.companyId === dmc.companyId);
//             if (exists) {
//                 return prev.filter(d => d.companyId !== dmc.companyId);
//             } else {
//                 return [...prev, dmc];
//             }
//         });
//     };

//     const handleConfirmSelection = () => {
//         if (selectedDmcs.length === 0) {
//             toast.warning("Please select at least one DMC");
//             return;
//         }
//         onSelectDmcs(selectedDmcs);
//         onHide();
//     };

//     return (
//         <Modal show={show} onHide={onHide} centered size="lg" scrollable>
//             <Modal.Header closeButton className="bg-light py-2">
//                 <Modal.Title className="fs-14 fw-bold">
//                     <i className="ri-building-line me-2 text-primary"></i>
//                     Select DMC Partners
//                     {selectedDmcs.length > 0 && (
//                         <Badge bg="primary" className="ms-2">
//                             {selectedDmcs.length} selected
//                         </Badge>
//                     )}
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body className="p-3" style={{ maxHeight: '70vh' }}>
//                 <div className="mb-3">
//                     <InputGroup size="sm">
//                         <InputGroup.Text className="bg-white border-end-0">
//                             <i className="ri-search-line text-muted"></i>
//                         </InputGroup.Text>
//                         <Form.Control
//                             size="sm"
//                             placeholder="Search DMCs..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             className="border-start-0 shadow-none"
//                         />
//                     </InputGroup>
//                 </div>

//                 <div className="d-flex justify-content-between align-items-center mb-2">
//                     <small className="text-muted">
//                         {filteredDmcs.length} DMC{filteredDmcs.length !== 1 ? 's' : ''} found
//                     </small>
//                     {selectedDmcs.length > 0 && (
//                         <Button 
//                             variant="link" 
//                             size="sm" 
//                             className="text-danger p-0"
//                             onClick={() => setSelectedDmcs([])}
//                         >
//                             Clear all
//                         </Button>
//                     )}
//                 </div>

//                 {isLoading ? (
//                     <div className="text-center py-4">
//                         <Spinner animation="border" variant="primary" size="sm" />
//                         <p className="mt-2 text-muted small">Loading DMCs...</p>
//                     </div>
//                 ) : filteredDmcs.length === 0 ? (
//                     <div className="text-center py-4">
//                         <i className="ri-building-4-line fs-36 text-muted"></i>
//                         <p className="mt-2 text-muted small">No DMCs found</p>
//                     </div>
//                 ) : (
//                     <Row className="g-2">
//                         {filteredDmcs.map((dmc) => {
//                             const isSelected = selectedDmcs.some(d => d.companyId === dmc.companyId);
//                             const destinations = dmc.destinations ? dmc.destinations.split(', ') : [];

//                             return (
//                                 <Col xs={12} sm={6} md={4} key={dmc.companyId}>
//                                     <Card
//                                         className={`shadow-sm border-2 ${isSelected ? 'border-primary bg-light' : 'border-light'}`}
//                                         style={{
//                                             cursor: 'pointer',
//                                             transition: 'all 0.15s ease',
//                                             backgroundColor: isSelected ? '#f0f7ff' : '#ffffff'
//                                         }}
//                                         onClick={() => toggleDmcSelection(dmc)}
//                                     >
//                                         <Card.Body className="p-2">
//                                             <div className="d-flex align-items-start">
//                                                 <div
//                                                     className="rounded-circle d-flex align-items-center justify-content-center me-2 flex-shrink-0"
//                                                     style={{
//                                                         width: '36px',
//                                                         height: '36px',
//                                                         backgroundColor: '#e8f0fe',
//                                                         border: isSelected ? '2px solid #0d6efd' : '1px solid #dee2e6'
//                                                     }}
//                                                 >
//                                                     {dmc.logoUrl ? (
//                                                         <img
//                                                             src={dmc.logoUrl}
//                                                             alt={dmc.companyName}
//                                                             style={{ width: '30px', height: '30px', objectFit: 'contain', borderRadius: '50%' }}
//                                                         />
//                                                     ) : (
//                                                         <span className="fw-bold fs-14 text-primary">
//                                                             {dmc.companyName?.charAt(0) || 'D'}
//                                                         </span>
//                                                     )}
//                                                 </div>

//                                                 <div className="flex-grow-1" style={{ minWidth: 0 }}>
//                                                     <div className="d-flex justify-content-between align-items-start">
//                                                         <div>
//                                                             <h6 className="fw-bold mb-0 text-dark" style={{ fontSize: '12px' }}>
//                                                                 {dmc.companyName}
//                                                             </h6>
//                                                             {dmc.brandName && (
//                                                                 <small className="text-muted" style={{ fontSize: '10px' }}>{dmc.brandName}</small>
//                                                             )}
//                                                         </div>
//                                                         {isSelected && (
//                                                             <Badge bg="primary" className="ms-1" style={{ fontSize: '8px', padding: '2px 5px' }}>
//                                                                 <i className="ri-check-line"></i>
//                                                             </Badge>
//                                                         )}
//                                                     </div>

//                                                     <div className="mt-1">
//                                                         <small className="text-muted d-block" style={{ fontSize: '10px' }}>
//                                                             <i className="ri-map-pin-line me-1 text-danger"></i>
//                                                             {dmc.city || 'N/A'}, {dmc.country || 'N/A'}
//                                                         </small>
//                                                     </div>

//                                                     {destinations.length > 0 && destinations[0] !== "MAIN" && (
//                                                         <div className="mt-1">
//                                                             <div className="d-flex flex-wrap gap-1">
//                                                                 {destinations.slice(0, 2).map((dest, idx) => (
//                                                                     <Badge key={idx} bg="light" text="dark" className="border" style={{ fontSize: '8px', padding: '1px 5px' }}>
//                                                                         {dest}
//                                                                     </Badge>
//                                                                 ))}
//                                                                 {destinations.length > 2 && (
//                                                                     <Badge bg="light" text="dark" className="border" style={{ fontSize: '8px', padding: '1px 5px' }}>
//                                                                         +{destinations.length - 2}
//                                                                     </Badge>
//                                                                 )}
//                                                             </div>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         </Card.Body>
//                                     </Card>
//                                 </Col>
//                             );
//                         })}
//                     </Row>
//                 )}
//             </Modal.Body>
//             <Modal.Footer className="bg-light py-2">
//                 <Button variant="secondary" size="sm" onClick={onHide}>
//                     Cancel
//                 </Button>
//                 <Button
//                     variant="primary"
//                     size="sm"
//                     onClick={handleConfirmSelection}
//                     disabled={selectedDmcs.length === 0}
//                 >
//                     <i className="ri-link-m me-1"></i>
//                     Connect {selectedDmcs.length} DMC{selectedDmcs.length !== 1 ? 's' : ''}
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//     );
// };

// // ============================================
// // HISTORY VIEW MODAL
// // ============================================
// const HistoryViewModal = ({ show, onHide, history }) => {
//     return (
//         <Modal show={show} onHide={onHide} centered scrollable size="md">
//             <Modal.Header closeButton className="bg-light">
//                 <Modal.Title className="fs-15 fw-bold text-uppercase">Lead Interaction History</Modal.Title>
//             </Modal.Header>
//             <Modal.Body className="p-4">
//                 {history && history.length > 0 ? (
//                     <div className="acitivity-timeline acitivity-main">
//                         {history.map((log, index) => (
//                             <div className="acitivity-item d-flex mb-3" key={index}>
//                                 <div className="flex-grow-1 ms-3 border-bottom pb-3">
//                                     <div className="d-flex justify-content-between align-items-center mb-1">
//                                         <h6 className="mb-0 fw-bold">Status: {log.status}</h6>
//                                     </div>
//                                     <div className="d-flex justify-content-between align-items-center mb-1">
//                                         <h6 className="mb-0 fw-bold">Message: {log.message}</h6>
//                                         <small className="text-muted">{moment(log.createdDate).format("DD MMM, HH:mm")}</small>
//                                     </div>
//                                     <small className="fw-medium text-primary">
//                                         <i className="ri-user-star-line me-1"></i> Updated by: {log.userName || "Unknown"}
//                                     </small>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 ) : (
//                     <p className="text-center text-muted">No history logs found.</p>
//                 )}
//             </Modal.Body>
//         </Modal>
//     );
// };

// // ============================================
// // MAIN COMPONENT
// // ============================================
// const PackageEnquiryList = () => {
//     const { user, loading } = useAuth();
//     const navigate = useNavigate();

//     const [leads, setLeads] = useState([]);
//     const [selectedItem, setSelectedItem] = useState(null);
//     const [editData, setEditData] = useState({});
//     const [isListLoading, setIsListLoading] = useState(false);
//     const [showHistoryModal, setShowHistoryModal] = useState(false);
//     const [showDmcModal, setShowDmcModal] = useState(false);
    
//     const [activeDmcChats, setActiveDmcChats] = useState([]);
//     const [activeChatId, setActiveChatId] = useState(null);
//     const [activeTab, setActiveTab] = useState('details');
    
//     const today = moment().format('YYYY-MM-DD');
//     const [fromDate, setFromDate] = useState(today);
//     const [toDate, setToDate] = useState(today);
//     const [localSearch, setLocalSearch] = useState("");
//     const [statusFilter, setStatusFilter] = useState("");

//     const [totalPages, setTotalPages] = useState(0);
//     const [pageSize, setPageSize] = useState(20);
//     const [pageNumber, setPageNumber] = useState(1);
//     const [totalRecords, setTotalRecords] = useState(0);

//     const fetchDmcChatsForLead = async (leadId) => {
//         try {
//             const response = await apiService.get(`${config.GET_DMC_CHATS_BY_LEAD}/${leadId}`);
//             if (response && response.data) {
//                 setActiveDmcChats(response.data);
//                 if (response.data.length > 0) {
//                     setActiveChatId(response.data[0].chatId);
//                 } else {
//                     setActiveChatId(null);
//                 }
//             }
//         } catch (error) {
//             console.error('Error fetching DMC chats:', error);
//             setActiveDmcChats([]);
//             setActiveChatId(null);
//         }
//     };

//     const refreshDmcChats = async () => {
//         if (selectedItem) {
//             await fetchDmcChatsForLead(selectedItem.leadId);
//         }
//     };

//     const GetLeads = async (pageNum = 1) => {
//         if (!user) return;

//         setIsListLoading(true);
//         let resourceUrl = `${config.GETLEADSBYUSER}/${user.id}?PageNumber=${pageNum}&PageSize=${pageSize}&enquiryType=PACKAGE`;

//         if (localSearch) resourceUrl += `&search=${encodeURIComponent(localSearch)}`;
//         if (fromDate) resourceUrl += `&fromDate=${fromDate}`;
//         if (toDate) resourceUrl += `&toDate=${toDate}`;
//         if (statusFilter) resourceUrl += `&status=${encodeURIComponent(statusFilter)}`;

//         try {
//             const res = await apiService.getAll(resourceUrl);
//             if (res && res.data.data) {
//                 const filteredData = res.data.data.filter(lead => 
//                     lead.leadStatus?.toUpperCase() !== "CONVERTED TO DEAL"
//                 );
//                 setLeads(filteredData);
//                 setPageNumber(res.pageNumber || 1);
//                 setPageSize(res.pageSize || 20);
//                 setTotalPages(res.totalPages || 0);
//                 setTotalRecords(res.totalRecords || filteredData.length);
//             } else {
//                 setLeads([]);
//                 setTotalRecords(0);
//                 setTotalPages(0);
//             }
//         } catch (error) {
//             console.error("Error fetching leads:", error);
//             setLeads([]);
//             setTotalRecords(0);
//             setTotalPages(0);
//         } finally {
//             setIsListLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (user && !loading) {
//             GetLeads(1);
//         }
//     }, [user, loading]);

//     useEffect(() => {
//         if (pageNumber > 0 && user) {
//             GetLeads(pageNumber);
//         }
//     }, [pageNumber]);

//     const handleSelectItem = async (item) => {
//         setSelectedItem(item);
//         setEditData(item ? { ...item } : {});
//         setActiveTab('details');
//         if (item) {
//             await fetchDmcChatsForLead(item.leadId);
//         } else {
//             setActiveDmcChats([]);
//             setActiveChatId(null);
//         }
//     };

//     const handleLocalChange = (field, value) => {
//         setEditData(prev => ({ ...prev, [field]: value }));
//     };

//     const updateLeadStatus = async () => {
//         if (!selectedItem) return;

//         const payload = {
//             leadId: selectedItem.leadId,
//             leadStatus: editData.leadStatus,
//             callBack: editData.callBack || null,
//             newLog: {
//                 userId: user.id,
//                 userName: user.name,
//                 status: editData.leadStatus,
//                 message: editData.comment || "Status updated"
//             }
//         };

//         try {
//             const res = await apiService.update(config.UPDATE_LEAD_STATUS, payload);

//             if (res) {
//                 setEditData(prev => ({ ...prev, comment: "" }));
//                 await GetLeads(pageNumber);

//                 const updatedHistoryEntry = {
//                     ...payload.newLog,
//                     createdDate: new Date().toISOString()
//                 };

//                 setSelectedItem(prev => ({
//                     ...prev,
//                     leadStatus: editData.leadStatus,
//                     callBack: editData.callBack || null,
//                     history: prev.history ? [...prev.history, updatedHistoryEntry] : [updatedHistoryEntry]
//                 }));
//                 toast.success("Lead status updated successfully!");
//             }
//         } catch (error) {
//             console.error("Update error:", error);
//             toast.error("Failed to update status");
//         }
//     };

//     const getItemId = (item) => item.leadId;
//     const getItemStatus = (item) => item.leadStatus || 'NEW';
//     const getItemEmail = (item) => item.email || '--';
//     const getItemPhone = (item) => item.phoneNumber || '--';
//     const getItemCreatedDate = (item) => item.createdDate;
//     const getItemUpdatedDate = (item) => item.updatedDate;
//     const getItemServiceDetails = (item) => item.serviceDetails || {};
//     const getItemDescription = (item) => item.description || "No specific customer requirements.";

//     const getSourceIcon = (source) => {
//         const s = source?.toLowerCase() || "";
//         if (s.includes("facebook")) return { icon: "ri-facebook-fill", bg: "#e8f1f9", color: "#1877f2" };
//         if (s.includes("whatsapp")) return { icon: "ri-whatsapp-line", bg: "#e6fffa", color: "#25d366" };
//         if (s.includes("website")) return { icon: "ri-global-line", bg: "#e0f2ff", color: "#00a3ff" };
//         if (s.includes("phone")) return { icon: "ri-phone-line", bg: "#e8f5e9", color: "#4caf50" };
//         return { icon: "ri-user-line", bg: "#f3f4f6", color: "#6b7280" };
//     };

//     const handleDmcSelection = async (selectedDmcs) => {
//         try {
//             setIsListLoading(true);
            
//             const dmcIds = selectedDmcs.map(d => d.companyId);
//             const dmcNames = selectedDmcs.map(d => d.companyName);
            
//             const formData = new FormData();
//             formData.append('leadId', selectedItem.leadId);
//             formData.append('dmcCompanyIds', dmcIds.join(','));
//             formData.append('dmcCompanyNames', dmcNames.join(','));
            
//             // No initialMessage - backend will build it

//             const response = await apiService.post(config.CREATE_MULTIPLE_DMC_CHATS, formData, {
//                 headers: { 'Content-Type': 'multipart/form-data' }
//             });
            
//             if (response && response.success) {
//                 const createdCount = response.data.totalCreated;
//                 toast.success(`Connected to ${createdCount} DMC${createdCount > 1 ? 's' : ''} successfully!`);
                
//                 await fetchDmcChatsForLead(selectedItem.leadId);
                
//                 if (response.data.createdChats && response.data.createdChats.length > 0) {
//                     setActiveChatId(response.data.createdChats[0].chatId);
//                     setActiveTab('chat');
//                 }
//             } else {
//                 toast.error("Failed to connect DMCs. Please try again.");
//             }
//         } catch (error) {
//             console.error("Error connecting DMCs:", error);
//             toast.error("Failed to connect DMCs. Please try again.");
//         } finally {
//             setIsListLoading(false);
//             setShowDmcModal(false);
//         }
//     };

//     const renderPagination = () => {
//         if (totalPages <= 1) return null;

//         const pageNumbers = [];
//         const maxVisiblePages = 5;

//         let startPage = Math.max(1, pageNumber - Math.floor(maxVisiblePages / 2));
//         let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

//         if (endPage - startPage + 1 < maxVisiblePages) {
//             startPage = Math.max(1, endPage - maxVisiblePages + 1);
//         }

//         for (let i = startPage; i <= endPage; i++) {
//             pageNumbers.push(i);
//         }

//         return (
//             <ul className="pagination pagination-separated pagination-sm mb-0">
//                 <li className={`page-item ${pageNumber === 1 ? "disabled" : ""}`} onClick={() => pageNumber > 1 && setPageNumber(pageNumber - 1)}>
//                     <Link to="#" className="page-link">Previous</Link>
//                 </li>
//                 {startPage > 1 && (
//                     <>
//                         <li className="page-item" onClick={() => setPageNumber(1)}><Link to="#" className="page-link">1</Link></li>
//                         {startPage > 2 && <li className="page-item disabled"><span className="page-link">...</span></li>}
//                     </>
//                 )}
//                 {pageNumbers.map((number) => (
//                     <li className={`page-item ${pageNumber === number ? "active" : ""}`} key={number} onClick={() => setPageNumber(number)}>
//                         <Link to="#" className="page-link">{number}</Link>
//                     </li>
//                 ))}
//                 {endPage < totalPages && (
//                     <>
//                         {endPage < totalPages - 1 && <li className="page-item disabled"><span className="page-link">...</span></li>}
//                         <li className="page-item" onClick={() => setPageNumber(totalPages)}><Link to="#" className="page-link">{totalPages}</Link></li>
//                     </>
//                 )}
//                 <li className={`page-item ${pageNumber === totalPages ? "disabled" : ""}`} onClick={() => pageNumber < totalPages && setPageNumber(pageNumber + 1)}>
//                     <Link to="#" className="page-link">Next</Link>
//                 </li>
//             </ul>
//         );
//     };

//     const handleSearch = () => {
//         setPageNumber(1);
//         GetLeads(1);
//     };

//     const handleReset = () => {
//         const todayDate = moment().format('YYYY-MM-DD');
//         setFromDate(todayDate);
//         setToDate(todayDate);
//         setLocalSearch("");
//         setStatusFilter("");
//         setPageNumber(1);
//         setTimeout(() => GetLeads(1), 100);
//     };

//     const handleStatusFilterChange = (e) => setStatusFilter(e.target.value);
//     const isFollowUpStatus = editData.leadStatus?.toUpperCase() === "FOLLOW UP";

//     if (loading) return <div className="p-5 text-center">Loading Dashboard...</div>;

//     return (
//         <div id="layout-wrapper" style={styles.pageBg}>
//             <Header User={user} activeSection="packages" />
//             <HistoryViewModal show={showHistoryModal} onHide={() => setShowHistoryModal(false)} history={selectedItem?.history} />
//             <DmcSelectionModal show={showDmcModal} onHide={() => setShowDmcModal(false)} onSelectDmcs={handleDmcSelection} />
            
//             <div className="main-content">
//                 <div className="page-content">
//                     <div className="container-fluid">
//                         <div className="row mt-3 g-0 shadow-lg rounded-4 overflow-hidden border border-light" style={{ height: '82vh', backgroundColor: "#fff" }}>

//                             {/* LEFT SIDEBAR - Leads List */}
//                             <div className="col-lg-3 border-end d-flex flex-column h-100" style={{ backgroundColor: "#fcfcfc", overflow: 'hidden' }}>
//                                 <div className="p-3 bg-white border-bottom" style={{ flexShrink: 0 }}>
//                                     <div className="d-flex justify-content-between align-items-center mb-3">
//                                         <h6 className="fw-bold text-dark mb-0">Package Leads</h6>
//                                         <Badge bg="primary">{leads.length}</Badge>
//                                     </div>

//                                     <Row className="g-2 mb-2">
//                                         <Col xs={6}>
//                                             <Form.Label className="small text-muted mb-0" style={{ fontSize: '9px' }}>FROM</Form.Label>
//                                             <Form.Control type="date" size="sm" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//                                         </Col>
//                                         <Col xs={6}>
//                                             <Form.Label className="small text-muted mb-0" style={{ fontSize: '9px' }}>TO</Form.Label>
//                                             <Form.Control type="date" size="sm" value={toDate} onChange={(e) => setToDate(e.target.value)} />
//                                         </Col>
//                                     </Row>

//                                     <div className="mb-2">
//                                         <Form.Label className="small text-muted mb-0" style={{ fontSize: '9px' }}>STATUS</Form.Label>
//                                         <Form.Select size="sm" value={statusFilter} onChange={handleStatusFilterChange}>
//                                             <option value="">All Status</option>
//                                             {leadStatusOptions.map((status) => (
//                                                 <option key={status} value={status}>{status}</option>
//                                             ))}
//                                         </Form.Select>
//                                     </div>

//                                     <InputGroup size="sm" className="mb-2">
//                                         <Form.Control
//                                             className="bg-light border-end-0 shadow-none"
//                                             placeholder="Search by name, phone or email..."
//                                             value={localSearch}
//                                             onChange={(e) => setLocalSearch(e.target.value)}
//                                             onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
//                                         />
//                                     </InputGroup>

//                                     <Row className="g-2">
//                                         <Col xs={6}>
//                                             <Button variant="primary" size="sm" className="w-100" onClick={handleSearch}>
//                                                 <i className="ri-search-line me-1"></i> Search
//                                             </Button>
//                                         </Col>
//                                         <Col xs={6}>
//                                             <Button variant="danger" size="sm" className="w-100" onClick={handleReset}>
//                                                 <i className="ri-refresh-line me-1"></i> Reset
//                                             </Button>
//                                         </Col>
//                                     </Row>
//                                 </div>

//                                 <div className="flex-grow-1 overflow-auto p-2 custom-scrollbar" style={{ overflowY: 'auto' }}>
//                                     {isListLoading ? (
//                                         <div className="d-flex flex-column align-items-center justify-content-center h-50">
//                                             <Spinner animation="border" variant="primary" />
//                                             <p className="mt-2 text-muted small">Loading leads...</p>
//                                         </div>
//                                     ) : leads.length === 0 ? (
//                                         <div className="text-center mt-5"><p className="text-muted">No package leads found.</p></div>
//                                     ) : (
//                                         leads.map((item) => {
//                                             const itemId = getItemId(item);
//                                             const isActive = selectedItem && getItemId(selectedItem) === itemId;
//                                             const src = getSourceIcon(item.sourceName);
//                                             const status = getItemStatus(item);
//                                             const statusColor = getStatusColor(status);

//                                             return (
//                                                 <div
//                                                     key={itemId}
//                                                     onClick={() => handleSelectItem(item)}
//                                                     className="p-3 mb-2 cursor-pointer position-relative"
//                                                     style={{
//                                                         marginBottom: "12px",
//                                                         borderRadius: "8px",
//                                                         transition: "all 0.2s ease",
//                                                         background: isActive ? "linear-gradient(to right, #eef4ff, #ffffff)" : "#fff",
//                                                         borderTop: isActive ? "1px solid #b7cced" : "1px solid #e9ebec",
//                                                         borderRight: isActive ? "1px solid #b7cced" : "1px solid #e9ebec",
//                                                         borderBottom: isActive ? "1px solid #b7cced" : "1px solid #e9ebec",
//                                                         borderLeft: `4px solid ${isActive ? "#405189" : statusColor}`,
//                                                         boxShadow: isActive ? "0 4px 6px rgba(0,0,0,0.05)" : "none",
//                                                         cursor: 'pointer'
//                                                     }}
//                                                 >
//                                                     <div className="d-flex">
//                                                         <div className="d-flex flex-column align-items-center me-3" style={{ minWidth: '50px' }}>
//                                                             <div className="avatar-sm rounded-circle d-flex align-items-center justify-content-center mb-1" style={{ backgroundColor: src.bg, color: src.color }}>
//                                                                 <i className={`${src.icon} fs-20`}></i>
//                                                             </div>
//                                                             <small className="text-muted text-center fw-bold" style={{ fontSize: '9px', lineHeight: '1.1' }}>{item.sourceName || "Manual"}</small>
//                                                         </div>
//                                                         <div className="flex-grow-1 overflow-hidden">
//                                                             <div className="d-flex justify-content-between align-items-start mb-1">
//                                                                 <h6 className="mb-0 text-truncate fw-bold text-dark" style={{ fontSize: '14px', maxWidth: '65%' }} title={item.name}>
//                                                                     {item.name || 'Unknown'}
//                                                                 </h6>
//                                                                 <span className={`${getLeadStatusBadge(status)}`} style={{ fontSize: '9px' }}>{status}</span>
//                                                             </div>
//                                                             <div className="mb-2">
//                                                                 <div className="d-flex align-items-center text-black small mb-1" title={item.email}>
//                                                                     <i className="ri-mail-line me-2 text-primary"></i>
//                                                                     <span className="text-truncate">{item.email || "--"}</span>
//                                                                 </div>
//                                                                 <div className="d-flex align-items-center text-black small" title={item.phoneNumber}>
//                                                                     <i className="ri-phone-line me-2 text-success"></i>
//                                                                     <span className="text-truncate">{item.phoneNumber || "--"}</span>
//                                                                 </div>
//                                                             </div>
//                                                             <div className="d-flex justify-content-between border-top pt-2 mt-1">
//                                                                 <small className="text-black" style={{ fontSize: '10px' }}>Cr: <span className="fw-bold">{moment(getItemCreatedDate(item)).format("DD MMM HH:mm")}</span></small>
//                                                                 <small className="text-black" style={{ fontSize: '10px' }}>Upd: <span className="fw-bold">{moment(getItemUpdatedDate(item)).format("DD MMM HH:mm")}</span></small>
//                                                             </div>
//                                                             {item.dmcConnected && (
//                                                                 <div className="mt-1">
//                                                                     <Badge bg="info" className="p-1" style={{ fontSize: '8px' }}>
//                                                                         <i className="ri-chat-3-line me-1"></i> Chat Active
//                                                                     </Badge>
//                                                                 </div>
//                                                             )}
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             );
//                                         })
//                                     )}
//                                 </div>

//                                 {leads.length > 0 && totalPages > 1 && (
//                                     <div className="p-2 border-top bg-white" style={{ flexShrink: 0 }}>
//                                         <div className="d-flex justify-content-center">{renderPagination()}</div>
//                                     </div>
//                                 )}
//                             </div>

//                             {/* RIGHT WORKSPACE */}
//                             <div className="col-lg-9 d-flex flex-column h-100" style={{ backgroundColor: "#f8f9fa", overflow: 'hidden' }}>
//                                 {selectedItem ? (
//                                     <>
//                                         {/* Header */}
//                                         <div className="p-3 shadow-sm d-flex justify-content-between align-items-center bg-white border-bottom" style={{ ...styles.summaryStrip, flexShrink: 0 }}>
//                                             <div className="d-flex align-items-center">
//                                                 <div className="avatar-md rounded-circle d-flex align-items-center justify-content-center me-3 fw-bold fs-20 shadow-lg" style={{ background: "linear-gradient(135deg, #405189 0%, #0ab39c 100%)", color: "#fff" }}>
//                                                     {selectedItem.name?.charAt(0) || '?'}
//                                                 </div>
//                                                 <div>
//                                                     <h5 className="fw-bold mb-0 text-dark">{selectedItem.name || 'Unknown'}</h5>
//                                                     <div className="d-flex align-items-center text-muted small">
//                                                         <i className="ri-phone-line me-1 text-success"></i> {getItemPhone(selectedItem)}
//                                                         <span className="mx-2 text-muted">|</span>
//                                                         <i className="ri-mail-line me-1 text-primary"></i> {getItemEmail(selectedItem)}
//                                                         <span className="mx-2 text-muted">|</span>
//                                                         <i className="ri-calendar-line me-1 text-info"></i> {moment(getItemCreatedDate(selectedItem)).format("DD MMM YYYY")}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="d-flex gap-2">
//                                                 <Button variant="success" size="sm" className="rounded-pill px-3 fw-bold" onClick={() => window.open(`https://web.whatsapp.com/send?phone=${selectedItem.phoneNumber}`)}>
//                                                     <i className="ri-whatsapp-line me-1"></i> WhatsApp
//                                                 </Button>
//                                                 <Button variant="primary" size="sm" className="rounded-pill px-3 fw-bold" onClick={() => window.location.href = `mailto:${selectedItem.email}`}>
//                                                     <i className="ri-mail-line me-1"></i> Email
//                                                 </Button>
//                                                 <Button variant="primary" size="sm" className="shadow-sm" onClick={() => navigate('/createpackage', { state: { leadId: selectedItem.leadId } })}>
//                                                     <i className="ri-add-line"></i> Create Package
//                                                 </Button>
//                                                 <Button variant="info" size="sm" className="shadow-sm text-white fw-bold" onClick={() => setShowDmcModal(true)}>
//                                                     <i className="ri-link-m me-1"></i> Connect DMC
//                                                 </Button>
//                                             </div>
//                                         </div>

//                                         {/* Tabs */}
//                                         <div className="flex-grow-1 overflow-hidden" style={{ display: 'flex', flexDirection: 'column' }}>
//                                             <Tabs 
//                                                 activeKey={activeTab} 
//                                                 onSelect={(k) => setActiveTab(k)}
//                                                 className="border-bottom bg-white" 
//                                                 style={{ flexShrink: 0 }}
//                                             >
//                                                 <Tab eventKey="details" title="Enquiry Details">
//                                                     <div className="p-3 overflow-auto" style={{ height: '58vh' }}>
//                                                         <Row className="gy-3">
//                                                             <Col md={9}>
//                                                                 <Card className="border-0 shadow-sm rounded-3 overflow-hidden">
//                                                                     <Card.Body className="p-0">
//                                                                         <div className="p-4 bg-white">
//                                                                             <h6 className="fw-bold text-dark mb-3 text-uppercase small ls-1">Detailed Requirements</h6>
//                                                                             <div className="border rounded overflow-hidden">
//                                                                                 <Row className="g-0">
//                                                                                     {Object.entries(getItemServiceDetails(selectedItem) || {}).map(([key, value], index) => {
//                                                                                         const displayKey = key.replace(/([A-Z])/g, ' $1').trim();
//                                                                                         const isBoolean = value?.toString().toLowerCase() === "true" || value?.toString().toLowerCase() === "false";
//                                                                                         const isPositive = value?.toString().toLowerCase() === "true";

//                                                                                         return (
//                                                                                             <Col xs={6} md={3} key={key} className={`p-3 border-bottom ${index % 4 !== 3 ? 'border-end' : ''}`} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#fcfcfc' }}>
//                                                                                                 <div style={styles.gridLabel}>{displayKey}</div>
//                                                                                                 {isBoolean ? (
//                                                                                                     <Badge bg={isPositive ? "success" : "light"} className={`mt-1 ${isPositive ? "" : "text-muted border"}`}>
//                                                                                                         {isPositive ? "YES" : "NO"}
//                                                                                                     </Badge>
//                                                                                                 ) : (
//                                                                                                     <div style={styles.gridValue} className="mt-1 text-truncate" title={value?.toString()}>{value?.toString() || "-"}</div>
//                                                                                                 )}
//                                                                                             </Col>
//                                                                                         );
//                                                                                     })}
//                                                                                     {Object.keys(getItemServiceDetails(selectedItem) || {}).length === 0 && (
//                                                                                         <Col xs={12} className="p-3 text-center text-muted">No additional details available</Col>
//                                                                                     )}
//                                                                                 </Row>
//                                                                                 <div className="px-4 py-3 bg-white border-bottom">
//                                                                                     <div className="d-flex">
//                                                                                         <i className="ri-double-quotes-l text-primary fs-20 me-2 opacity-50"></i>
//                                                                                         <p className="mb-0 text-black fst-bold">{getItemDescription(selectedItem)}</p>
//                                                                                     </div>
//                                                                                 </div>
//                                                                             </div>
//                                                                         </div>
//                                                                     </Card.Body>
//                                                                 </Card>
//                                                             </Col>

//                                                             <Col md={3}>
//                                                                 <Card className="shadow-none border rounded-3">
//                                                                     <Card.Header className="bg-light py-2 d-flex justify-content-between align-items-center">
//                                                                         <h6 className="mb-0 fw-bold small text-primary">STATUS CONTROL</h6>
//                                                                         <Link to="#" onClick={() => setShowHistoryModal(true)} title="View Audit Trail">
//                                                                             <i className="ri-history-line fs-16 text-muted">View History</i>
//                                                                         </Link>
//                                                                     </Card.Header>
//                                                                     <Card.Body className="p-3">
//                                                                         <Form.Group className="mb-2">
//                                                                             <Form.Label className="text-muted small fw-bold">STATUS</Form.Label>
//                                                                             <Form.Select size="sm" value={editData.leadStatus || ""} onChange={e => handleLocalChange('leadStatus', e.target.value)}>
//                                                                                 <option value="NEW">NEW</option>
//                                                                                 <option value="PROCESSING">PROCESSING</option>
//                                                                                 <option value="FOLLOW UP">FOLLOW UP</option>
//                                                                                 <option value="REPLIED">REPLIED</option>
//                                                                                 <option value="NOT RESPONDING">NOT RESPONDING</option>
//                                                                                 <option value="NOT WORKING">NOT WORKING</option>
//                                                                                 <option value="CLOSED">CLOSED</option>
//                                                                                 <option value="WON">WON</option>
//                                                                                 <option value="LOST">LOST</option>
//                                                                             </Form.Select>
//                                                                         </Form.Group>
                                                                        
//                                                                         {isFollowUpStatus && (
//                                                                             <Form.Group className="mb-2">
//                                                                                 <Form.Label className="text-muted small fw-bold">NEXT CALL</Form.Label>
//                                                                                 <Form.Control size="sm" type="datetime-local" value={editData.callBack ? moment(editData.callBack).format("YYYY-MM-DDTHH:mm") : ""} onChange={e => handleLocalChange('callBack', e.target.value)} />
//                                                                             </Form.Group>
//                                                                         )}

//                                                                         <Form.Group className="mb-2">
//                                                                             <Form.Label className="text-muted small fw-bold">NOTE / COMMENT</Form.Label>
//                                                                             <Form.Control as="textarea" rows={2} size="sm" placeholder="Type status update..." value={editData.comment || ""} onChange={e => handleLocalChange('comment', e.target.value)} />
//                                                                         </Form.Group>

//                                                                         <Button variant="primary" size="sm" className="w-100 fw-bold mt-2" onClick={updateLeadStatus}>
//                                                                             Update Status
//                                                                         </Button>
//                                                                     </Card.Body>
//                                                                 </Card>
//                                                             </Col>
//                                                         </Row>
//                                                     </div>
//                                                 </Tab>

//                                                 <Tab eventKey="chat" title={
//                                                     <span>
//                                                         <i className="ri-chat-3-line me-1"></i>
//                                                         Chat
//                                                         {activeDmcChats.length > 0 && (
//                                                             <Badge bg="info" className="ms-1" style={{ fontSize: '9px' }}>
//                                                                 {activeDmcChats.length}
//                                                             </Badge>
//                                                         )}
//                                                     </span>
//                                                 }>
//                                                     <div className="p-0" style={{ height: '58vh' }}>
//                                                         {activeDmcChats.length === 0 ? (
//                                                             <div className="d-flex flex-column align-items-center justify-content-center h-100 text-muted">
//                                                                 <i className="ri-chat-smile-3-line fs-48 mb-3"></i>
//                                                                 <p>No DMC chats available for this enquiry.</p>
//                                                                 <Button variant="info" size="sm" className="text-white" onClick={() => setShowDmcModal(true)}>
//                                                                     <i className="ri-link-m me-1"></i> Connect DMC
//                                                                 </Button>
//                                                             </div>
//                                                         ) : (
//                                                             <div className="d-flex h-100">
//                                                                 <div className="border-end" style={{ width: '250px', overflowY: 'auto', flexShrink: 0 }}>
//                                                                     <div className="p-2 bg-light border-bottom">
//                                                                         <small className="fw-bold text-muted">DMC Conversations</small>
//                                                                     </div>
//                                                                     {activeDmcChats.map((chat) => (
//                                                                         <div
//                                                                             key={chat.chatId}
//                                                                             className={`p-2 border-bottom cursor-pointer ${activeChatId === chat.chatId ? 'bg-primary bg-opacity-10' : ''}`}
//                                                                             style={{ cursor: 'pointer' }}
//                                                                             onClick={() => setActiveChatId(chat.chatId)}
//                                                                         >
//                                                                             <div className="d-flex justify-content-between align-items-center">
//                                                                                 <div>
//                                                                                     <small className="fw-bold d-block">{chat.dmcCompanyName}</small>
//                                                                                     <small className="text-muted" style={{ fontSize: '10px' }}>
//                                                                                         {chat.summary?.lastMessagePreview?.substring(0, 30) || 'No messages'}
//                                                                                     </small>
//                                                                                 </div>
//                                                                                 {chat.summary?.unreadCount > 0 && (
//                                                                                     <Badge bg="danger" pill>
//                                                                                         {chat.summary.unreadCount}
//                                                                                     </Badge>
//                                                                                 )}
//                                                                             </div>
//                                                                         </div>
//                                                                     ))}
//                                                                 </div>

//                                                                 <div className="flex-grow-1">
//                                                                     {activeChatId ? (
//                                                                         <DmcChatView 
//                                                                             chatId={activeChatId} 
//                                                                             leadId={selectedItem.leadId}
//                                                                             onClose={() => setActiveChatId(null)}
//                                                                             onMessageSent={refreshDmcChats}
//                                                                         />
//                                                                     ) : (
//                                                                         <div className="d-flex flex-column align-items-center justify-content-center h-100 text-muted">
//                                                                             <i className="ri-chat-3-line fs-48 mb-3"></i>
//                                                                             <p>Select a DMC conversation to view</p>
//                                                                         </div>
//                                                                     )}
//                                                                 </div>
//                                                             </div>
//                                                         )}
//                                                     </div>
//                                                 </Tab>
//                                             </Tabs>
//                                         </div>
//                                     </>
//                                 ) : (
//                                     <div className="h-100 d-flex flex-column align-items-center justify-content-center">
//                                         <div className="mb-3 avatar-lg bg-white rounded-circle shadow-sm d-flex align-items-center justify-content-center">
//                                             <i className="ri-inbox-line fs-36 text-primary"></i>
//                                         </div>
//                                         <h5 className="text-dark fw-bold">Welcome to Enquiry Manager</h5>
//                                         <p className="text-muted">Select a lead from the inbox to display details.</p>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default PackageEnquiryList;




import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import config from '../../Common/Configurations/APIConfig';
import apiService from "../../Common/Configurations/APIService";
import Header from '../../Common/Layout/Header';
import { useAuth } from '../../Common/Configurations/AuthContext';
import moment from 'moment';
import { Button, Form, Row, Col, Card, Badge, InputGroup, Modal, Spinner, Tab, Tabs } from 'react-bootstrap';
import { toast } from 'react-toastify';
import DefaultData from '../../CompanyData/DefaultData';

// --- ENHANCED STYLES ---
const styles = {
    pageBg: { backgroundColor: "#f3f4f6", minHeight: "100vh" },
    summaryStrip: {
        background: "#ffffff",
        color: "#212529",
        borderRadius: "0px",
        borderBottom: "1px solid #e9ebec"
    },
    gridLabel: {
        color: "#878a99",
        fontSize: "10px",
        textTransform: "uppercase",
        fontWeight: "700",
        letterSpacing: "0.5px"
    },
    gridValue: {
        color: "#212529",
        fontWeight: "600",
        fontSize: "13px"
    },
};

const leadStatusOptions = [
    "NEW", "FOLLOW UP", "REPLIED", "NOT RESPONDING", 
    "NOT WORKING", "CLOSED", "PROCESSING", "WON", "LOST"
];

const getStatusColor = (status) => {
    switch (status) {
        case 'NEW': return '#f06548';
        case 'PROCESSING': return '#f7b84b';
        case 'WON': return '#0ab39c';
        case 'LOST': return '#212529';
        case 'FOLLOW UP': return '#f7b84b';
        case 'CLOSED': return '#0ab39c';
        default: return '#405189';
    }
};

const getLeadStatusBadge = (status) => {
    const name = status?.toLowerCase();
    if (name?.includes('new')) return 'badge bg-primary text-white';
    if (name?.includes('follow up')) return 'badge bg-warning text-white';
    if (name?.includes('replied')) return 'badge bg-secondary text-white';
    if (name?.includes('not responding')) return 'badge bg-danger text-white';
    if (name?.includes('not working')) return 'badge bg-info text-white';
    if (name?.includes('closed')) return 'badge bg-success text-white';
    if (name?.includes('processing')) return 'badge bg-info text-white';
    if (name?.includes('won')) return 'badge bg-success text-white';
    if (name?.includes('lost')) return 'badge bg-danger text-white';
    return 'badge bg-light text-dark';
};

// ============================================
// DMC CHAT COMPONENT
// ============================================
const DmcChatView = ({ chatId, leadId, onClose, onMessageSent }) => {
    const [chat, setChat] = useState(null);
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [isSending, setIsSending] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [uploadProgress, setUploadProgress] = useState(0);
    const messagesEndRef = useRef(null);
    const fileInputRef = useRef(null);
    const { user } = useAuth();

    useEffect(() => {
        if (chatId) {
            fetchChat();
        }
    }, [chatId, refreshKey]);

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const fetchChat = async () => {
        try {
            setIsLoading(true);
            const response = await apiService.get(`${config.GET_DMC_CHAT_BY_ID}/${chatId}`);
            console.log('Fetched chat response:', response);
            
            if (response && response.data) {
                setChat(response.data);
                const msgs = response.data.messages || [];
                setMessages(msgs);
                await markMessagesAsRead(msgs);
            } else {
                console.error('No chat data received');
            }
        } catch (error) {
            console.error('Error fetching chat:', error);
            toast.error('Failed to load chat');
        } finally {
            setIsLoading(false);
        }
    };

    const markMessagesAsRead = async (msgs) => {
        const currentUserId = user?.id || 'current-user-id';
        const unreadMessages = msgs.filter(m => 
            !m.isRead && m.senderType !== 'STAFF'
        );
        
        for (const msg of unreadMessages) {
            try {
                await apiService.put(config.MARK_DMC_MESSAGE_READ, {
                    chatId: chatId,
                    messageId: msg.messageId,
                    readerId: currentUserId
                });
            } catch (err) {
                console.error('Error marking message as read:', err);
            }
        }
    };

    const sendMessage = async () => {
        if (!newMessage.trim() && selectedFiles.length === 0) {
            toast.warning('Please enter a message or attach a file');
            return;
        }

        try {
            setIsSending(true);
            setUploadProgress(0);
            
            const formData = new FormData();
            formData.append('chatId', chatId);
            formData.append('content', newMessage.trim() || 'Shared file(s)');
            formData.append('senderId', user?.id || 'current-user-id');
            formData.append('senderName', user?.name || 'You');
            formData.append('senderType', 'STAFF');
            formData.append('senderCompanyName', DefaultData.DEFAULTCOMPANYNAME);

            if (selectedFiles.length > 0) {
                selectedFiles.forEach((file, index) => {
                    formData.append('attachments', file, file.name);
                });
            }

            console.log('Sending message with files:', selectedFiles.length);

            const response = await apiService.postWithFile(
                config.SEND_DMC_CHAT_MESSAGE, 
                formData,
                true
            );

            console.log('Send message response:', response);

            if (response) {
                if (response.success !== false) {
                    if (response.data) {
                        setMessages(prev => [...prev, response.data]);
                    }
                    setNewMessage('');
                    setSelectedFiles([]);
                    setUploadProgress(0);
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                    }
                    if (onMessageSent) {
                        onMessageSent();
                    }
                    setRefreshKey(prev => prev + 1);
                } else {
                    toast.error(response?.message || 'Failed to send message');
                }
            }
        } catch (error) {
            console.error('Error sending message:', error);
        } finally {
            setIsSending(false);
            setUploadProgress(0);
        }
    };

    const handleFileSelect = (e) => {
        const files = Array.from(e.target.files);
        if (files.length === 0) return;
        
        setSelectedFiles(prev => [...prev, ...files]);
        toast.success(`${files.length} file(s) selected`);
    };

    const removeFile = (index) => {
        setSelectedFiles(prev => prev.filter((_, i) => i !== index));
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const scrollToBottom = () => {
        setTimeout(() => {
            messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    };

    const renderEnquiryDetails = (enquiryDetails) => {
        if (!enquiryDetails) return null;
        
        const details = enquiryDetails.serviceDetails || {};
        const entries = Object.entries(details);
        const requirementsText = enquiryDetails.requirements || enquiryDetails.Requirements || '';
        
        if (entries.length === 0 && !requirementsText) return null;
        
        const displayOrder = [
            'enquiryType', 'packageName', 'packageDestination', 'destination',
            'travelDate', 'startDate', 'returnDate',
            'adults', 'kids', 'infant', 'totalGuests', 'travelers',
            'packageDuration', 'duration', 'noOfDays',
            'packageType', 'packagePreference'
        ];
        
        const sortedEntries = [...entries].sort((a, b) => {
            const indexA = displayOrder.findIndex(key => a[0].toLowerCase().includes(key.toLowerCase()));
            const indexB = displayOrder.findIndex(key => b[0].toLowerCase().includes(key.toLowerCase()));
            if (indexA === -1 && indexB === -1) return 0;
            if (indexA === -1) return 1;
            if (indexB === -1) return -1;
            return indexA - indexB;
        });
        
        return (
            <div className="enquiry-details-container mb-2 p-3 rounded-3" style={{ 
                backgroundColor: '#f0f7ff', 
                border: '1px solid #cfe2ff',
                borderRadius: '12px'
            }}>
                <div className="d-flex align-items-center mb-2">
                    <i className="ri-file-list-3-line text-primary me-2" style={{ fontSize: '18px' }}></i>
                    <span className="fw-bold text-primary" style={{ fontSize: '13px' }}>📋 Enquiry Details</span>
                </div>
                
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2px 16px' }}>
                    {sortedEntries.map(([key, value]) => {
                        if (key.toLowerCase().includes('price') || 
                            key.toLowerCase().includes('cost') || 
                            key.toLowerCase().includes('amount') ||
                            key.toLowerCase().includes('total')) {
                            return null;
                        }
                        
                        if (key.toLowerCase().includes('requirements') || 
                            key.toLowerCase().includes('specialrequests') ||
                            key.toLowerCase().includes('description')) {
                            return null;
                        }
                        
                        if (key.toLowerCase().includes('reference') || 
                            (key.toLowerCase().includes('id') && !key.toLowerCase().includes('package'))) {
                            return null;
                        }
                        
                        let displayKey = key
                            .replace(/([A-Z])/g, ' $1')
                            .replace(/^./, str => str.toUpperCase())
                            .replace(/Package/g, '')
                            .trim();
                        
                        if (!displayKey) displayKey = key;
                        
                        let displayValue = value?.toString() || 'N/A';
                        
                        if (key.toLowerCase().includes('date') || key.toLowerCase().includes('travel')) {
                            if (displayValue !== 'N/A' && displayValue !== '') {
                                try {
                                    const date = moment(displayValue);
                                    if (date.isValid()) {
                                        displayValue = date.format('DD MMM YYYY');
                                    }
                                } catch (e) {}
                            }
                        }
                        
                        if (key.toLowerCase().includes('adults') || 
                            key.toLowerCase().includes('kids') || 
                            key.toLowerCase().includes('infant') ||
                            key.toLowerCase().includes('guests') ||
                            key.toLowerCase().includes('travelers')) {
                            if (displayValue !== 'N/A' && !isNaN(displayValue)) {
                                displayValue = `👤 ${displayValue}`;
                            }
                        }
                        
                        if (displayValue === '' || displayValue === 'N/A' || displayValue === 'Not specified') {
                            return null;
                        }
                        
                        return (
                            <div key={key} className="d-flex align-items-center py-1" style={{ borderBottom: '1px solid rgba(0,0,0,0.04)' }}>
                                <span style={{ 
                                    fontSize: '11px', 
                                    fontWeight: '500',
                                    color: '#6c757d',
                                    minWidth: '100px',
                                    flexShrink: 0
                                }}>
                                    {displayKey}:
                                </span>
                                <span style={{ 
                                    fontSize: '12px', 
                                    fontWeight: '500',
                                    color: '#212529',
                                    wordBreak: 'break-word'
                                }}>
                                    {displayValue}
                                </span>
                            </div>
                        );
                    })}
                </div>
                
                {requirementsText && requirementsText !== 'N/A' && (
                    <div className="mt-2 pt-2" style={{ borderTop: '1px solid rgba(0,0,0,0.08)' }}>
                        <div className="d-flex align-items-start">
                            <i className="ri-question-answer-line text-warning me-2 mt-1" style={{ fontSize: '16px' }}></i>
                            <div style={{ flex: 1 }}>
                                <span style={{ fontSize: '11px', fontWeight: '600', color: '#6c757d' }}>Requirements:</span>
                                <p className="mb-0 mt-1" style={{ 
                                    fontSize: '13px', 
                                    fontWeight: '500',
                                    color: '#212529',
                                    lineHeight: '1.6',
                                    wordBreak: 'break-word'
                                }}>
                                    {requirementsText}
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const renderMessageContent = (content, isStaff) => {
        if (!content) return null;
        
        const enquiryMarkers = [
            '📋 New Enquiry Notification',
            '━━━━━━━━━━━━━━━━━━━━━━━━━',
            '📌 Enquiry Type:',
            '🏢 COMPANY DETAILS',
            '👤 STAFF CONTACT'
        ];
        
        const hasEnquiryMarkers = enquiryMarkers.some(marker => content.includes(marker));
        
        if (hasEnquiryMarkers) {
            const lines = content.split('\n');
            const messageLines = [];
            let foundMessage = false;
            
            for (const line of lines) {
                if (line.includes('💬 Please review') || line.includes('Thank you!')) {
                    foundMessage = true;
                }
                
                if (foundMessage && line.trim()) {
                    messageLines.push(line);
                }
            }
            
            if (messageLines.length === 0) {
                const textLines = lines.filter(line => 
                    !enquiryMarkers.some(marker => line.includes(marker)) &&
                    !line.includes('━━━━━━━━━━━━━━━━━━━━━━━━━') &&
                    !line.includes('Company:') &&
                    !line.includes('Brand:') &&
                    !line.includes('Email:') &&
                    !line.includes('Phone:') &&
                    !line.includes('Staff:') &&
                    !line.includes('Name:') &&
                    !line.includes('📌') &&
                    !line.includes('🆔') &&
                    !line.includes('🏢') &&
                    !line.includes('👤') &&
                    line.trim()
                );
                
                if (textLines.length > 0) {
                    const fullText = textLines.join('\n');
                    if (fullText.includes('Package enquiry for') || 
                        fullText.includes('Requirements:')) {
                        return null;
                    }
                    
                    return (
                        <div className="message-content" style={{ 
                            fontSize: '13px', 
                            lineHeight: '1.6',
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word'
                        }}>
                            {fullText}
                        </div>
                    );
                }
                
                return null;
            }
            
            const messageText = messageLines.join('\n');
            if (messageText.includes('Please review') && messageText.includes('Thank you')) {
                return (
                    <div className="message-content" style={{ 
                        fontSize: '13px', 
                        lineHeight: '1.6',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                        fontStyle: 'italic',
                        color: '#6c757d'
                    }}>
                        {messageText}
                    </div>
                );
            }
            
            return (
                <div className="message-content" style={{ 
                    fontSize: '13px', 
                    lineHeight: '1.6',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word'
                }}>
                    {messageText}
                </div>
            );
        }
        
        return (
            <div className="message-content" style={{ 
                fontSize: '13px', 
                lineHeight: '1.6',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word'
            }}>
                {content}
            </div>
        );
    };

    const renderFileAttachment = (file, isStaff) => {
        if (!file) return null;
        
        const isImage = file.fileType?.startsWith('image/') || 
                       file.fileName?.match(/\.(jpg|jpeg|png|gif|webp|svg|bmp|ico|tiff|tif)$/i);
        
        const isVideo = file.fileType?.startsWith('video/') || 
                       file.fileName?.match(/\.(mp4|avi|mov|wmv|flv|mkv|webm|3gp)$/i);
        
        const isAudio = file.fileType?.startsWith('audio/') || 
                       file.fileName?.match(/\.(mp3|wav|aac|flac|ogg|wma)$/i);
        
        const isDocument = file.fileName?.match(/\.(pdf|doc|docx|xls|xlsx|ppt|pptx|txt|csv|rtf|odt)$/i);
        
        return (
            <div className="d-flex align-items-center mt-1">
                {isImage ? (
                    <a href={file.fileUrl} target="_blank" rel="noopener noreferrer" className="d-block">
                        <img 
                            src={file.fileUrl} 
                            alt={file.fileName}
                            style={{ 
                                maxWidth: '200px', 
                                maxHeight: '150px', 
                                borderRadius: '8px',
                                border: '1px solid #dee2e6',
                                objectFit: 'cover'
                            }}
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                    </a>
                ) : isVideo ? (
                    <video 
                        controls 
                        style={{ 
                            maxWidth: '250px', 
                            maxHeight: '200px', 
                            borderRadius: '8px',
                            border: '1px solid #dee2e6'
                        }}
                    >
                        <source src={file.fileUrl} />
                        Your browser does not support the video tag.
                    </video>
                ) : isAudio ? (
                    <audio controls style={{ maxWidth: '250px' }}>
                        <source src={file.fileUrl} />
                        Your browser does not support the audio tag.
                    </audio>
                ) : (
                    <a 
                        href={file.fileUrl} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className={`d-flex align-items-center small ${isStaff ? 'text-white-50' : 'text-primary'}`}
                        style={{ fontSize: '11px', textDecoration: 'none' }}
                    >
                        {isDocument ? (
                            <i className="ri-file-text-line me-1"></i>
                        ) : (
                            <i className="ri-file-line me-1"></i>
                        )}
                        📎 {file.fileName} ({(file.fileSizeKb || 0).toFixed(1)} KB)
                    </a>
                )}
            </div>
        );
    };

    const renderMessage = (msg, index) => {
        const isStaff = msg.senderType === 'STAFF';
        const isEnquiryDetails = msg.messageType === 'ENQUIRY_DETAILS';

        return (
            <div key={index} className={`d-flex mb-3 ${isStaff ? 'justify-content-end' : 'justify-content-start'}`}>
                <div className={`p-3 rounded-3 ${isStaff ? 'bg-primary text-white' : 'bg-white shadow-sm border'}`} style={{ maxWidth: '85%', minWidth: '200px' }}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <small className={`fw-bold ${isStaff ? 'text-white' : 'text-dark'}`} style={{ fontSize: '12px' }}>
                            {isStaff ? 'You' : (msg.senderName || chat?.dmcCompanyName)}
                        </small>
                        <small className={`ms-2 ${isStaff ? 'text-white-50' : 'text-muted'}`} style={{ fontSize: '10px' }}>
                            {moment(msg.sentAt).format('DD MMM, HH:mm')}
                        </small>
                    </div>

                    {isEnquiryDetails && msg.enquiryDetails && (
                        <div className="mb-2">
                            {renderEnquiryDetails(msg.enquiryDetails)}
                            {msg.content && (
                                <div className="mt-2 pt-2" style={{ borderTop: '1px solid rgba(0,0,0,0.08)' }}>
                                    <div className="d-flex align-items-center mb-1">
                                        <i className="ri-chat-2-line text-muted me-1" style={{ fontSize: '12px' }}></i>
                                        <span style={{ fontSize: '11px', fontWeight: '500', color: '#6c757d' }}>Message:</span>
                                    </div>
                                    {renderMessageContent(msg.content, isStaff)}
                                </div>
                            )}
                        </div>
                    )}

                    {!isEnquiryDetails && msg.content && (
                        <div className="mb-1" style={{ fontSize: '13px', wordBreak: 'break-word', lineHeight: '1.6' }}>
                            {msg.content}
                        </div>
                    )}

                    {msg.attachments && msg.attachments.length > 0 && (
                        <div className="mt-2">
                            {msg.attachments.map((file, idx) => (
                                <div key={idx} className="mb-1">
                                    {renderFileAttachment(file, isStaff)}
                                </div>
                            ))}
                        </div>
                    )}

                    {msg.isRead && isStaff && (
                        <small className="text-white-50 d-block mt-1" style={{ fontSize: '9px' }}>
                            <i className="ri-check-double-line me-1"></i> Read
                        </small>
                    )}
                </div>
            </div>
        );
    };

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center p-5" style={{ height: '100%' }}>
                <Spinner animation="border" variant="primary" />
                <span className="ms-2 text-muted small">Loading chat...</span>
            </div>
        );
    }

    if (!chat) {
        return (
            <div className="d-flex justify-content-center align-items-center p-5" style={{ height: '100%' }}>
                <p className="text-muted">Chat not found</p>
            </div>
        );
    }

    return (
        <div className="dmc-chat-container bg-white" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div className="p-2 border-bottom bg-light d-flex justify-content-between align-items-center" style={{ flexShrink: 0 }}>
                <div>
                    <h6 className="mb-0 fw-bold" style={{ fontSize: '13px' }}>
                        <i className="ri-chat-3-line me-2 text-primary"></i>
                        {chat.dmcCompanyName || 'DMC Chat'}
                    </h6>
                    <small className="text-muted" style={{ fontSize: '10px' }}>
                        Enquiry: {chat.enquiryType || 'Package'} • 
                        Status: <Badge bg={chat.status === 'ACTIVE' ? 'success' : 'secondary'} style={{ fontSize: '8px' }}>
                            {chat.status || 'ACTIVE'}
                        </Badge>
                    </small>
                </div>
                <div>
                    <Button variant="link" size="sm" className="text-danger p-0" onClick={onClose}>
                        <i className="ri-close-line fs-18"></i>
                    </Button>
                </div>
            </div>

            <div className="p-1 px-2 bg-light border-bottom" style={{ flexShrink: 0 }}>
                <small className="text-muted" style={{ fontSize: '9px' }}>
                    <i className="ri-building-line me-1"></i>
                    <strong>Your Company:</strong> {chat.userCompanyName || DefaultData.DEFAULTCOMPANYNAME}
                </small>
                <small className="text-muted ms-2" style={{ fontSize: '9px' }}>
                    <i className="ri-mail-line me-1"></i>
                    {chat.userEmail || DefaultData.DEFAULTCOMPANYEMAIL}
                </small>
                <small className="text-muted ms-2" style={{ fontSize: '9px' }}>
                    <i className="ri-phone-line me-1"></i>
                    +{chat.userPhoneNumber || DefaultData.DEFAULTCOMPANYPHONENUMBER}
                </small>
            </div>

            <div className="p-2 overflow-auto flex-grow-1" style={{ flex: 1, minHeight: 0, backgroundColor: '#f8f9fa' }}>
                {messages.length === 0 ? (
                    <div className="text-center text-muted py-4">
                        <i className="ri-chat-smile-3-line fs-36"></i>
                        <p className="mt-2" style={{ fontSize: '13px' }}>No messages yet. Start the conversation!</p>
                    </div>
                ) : (
                    messages.map((msg, index) => renderMessage(msg, index))
                )}
                <div ref={messagesEndRef} />
            </div>

            <div className="border-top p-2 bg-white" style={{ flexShrink: 0 }}>
                {selectedFiles.length > 0 && (
                    <div className="mb-1 d-flex flex-wrap gap-1">
                        {selectedFiles.map((file, index) => (
                            <Badge key={index} bg="light" text="dark" className="border p-1 d-flex align-items-center" style={{ fontSize: '10px' }}>
                                {file.type?.startsWith('image/') ? (
                                    <i className="ri-image-line me-1"></i>
                                ) : file.type?.startsWith('video/') ? (
                                    <i className="ri-video-line me-1"></i>
                                ) : file.type?.startsWith('audio/') ? (
                                    <i className="ri-music-line me-1"></i>
                                ) : (
                                    <i className="ri-file-line me-1"></i>
                                )}
                                {file.name} ({(file.size / 1024).toFixed(1)} KB)
                                <Button 
                                    variant="link" 
                                    size="sm" 
                                    className="p-0 ms-1 text-danger"
                                    onClick={() => removeFile(index)}
                                    style={{ fontSize: '10px', lineHeight: 1 }}
                                >
                                    <i className="ri-close-line"></i>
                                </Button>
                            </Badge>
                        ))}
                    </div>
                )}

                {uploadProgress > 0 && uploadProgress < 100 && (
                    <div className="mb-1">
                        <div className="d-flex align-items-center">
                            <small className="text-muted me-2" style={{ fontSize: '10px' }}>
                                Uploading... {uploadProgress}%
                            </small>
                            <div className="flex-grow-1" style={{ height: '4px', backgroundColor: '#e9ecef', borderRadius: '2px' }}>
                                <div 
                                    style={{ 
                                        width: `${uploadProgress}%`, 
                                        height: '100%', 
                                        backgroundColor: '#0d6efd', 
                                        borderRadius: '2px',
                                        transition: 'width 0.3s ease'
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}

                <div className="d-flex gap-1">
                    <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileSelect}
                        multiple
                        style={{ display: 'none' }}
                    />
                    <Button 
                        variant="outline-secondary" 
                        size="sm"
                        onClick={() => fileInputRef.current?.click()}
                        disabled={isSending || chat.status !== 'ACTIVE'}
                        style={{ padding: '4px 8px' }}
                        title="Attach files"
                    >
                        <i className="ri-attachment-2"></i>
                    </Button>
                    <Form.Control
                        size="sm"
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && !e.shiftKey && sendMessage()}
                        placeholder="Type your message..."
                        disabled={isSending || chat.status !== 'ACTIVE'}
                        style={{ fontSize: '13px' }}
                    />
                    <Button 
                        variant="primary" 
                        size="sm"
                        onClick={sendMessage} 
                        disabled={isSending || (!newMessage.trim() && selectedFiles.length === 0)}
                        style={{ padding: '4px 12px' }}
                    >
                        {isSending ? <Spinner size="sm" animation="border" /> : <i className="ri-send-plane-line"></i>}
                    </Button>
                </div>
            </div>
        </div>
    );
};

// ============================================
// DMC SELECTION MODAL
// ============================================
const DmcSelectionModal = ({ show, onHide, onSelectDmcs }) => {
    const [dmcs, setDmcs] = useState([]);
    const [filteredDmcs, setFilteredDmcs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedDmcs, setSelectedDmcs] = useState([]);

    const parentCompanyId = DefaultData.DEFAULTCOMPANYID;

    useEffect(() => {
        if (show) fetchDmcs();
    }, [show]);

    useEffect(() => {
        filterDmcs();
    }, [searchTerm, dmcs]);

    const fetchDmcs = async () => {
        setIsLoading(true);
        try {
            const url = `${config.GETDMCS}/${parentCompanyId}`;
            const response = await apiService.getAll(url);
            if (response && response.data) {
                setDmcs(response.data);
                setFilteredDmcs(response.data);
            }
        } catch (error) {
            console.error("Error fetching DMCs:", error);
            toast.error("Failed to load DMCs");
        } finally {
            setIsLoading(false);
        }
    };

    const filterDmcs = () => {
        if (!searchTerm.trim()) {
            setFilteredDmcs(dmcs);
            return;
        }
        const lowerSearch = searchTerm.toLowerCase();
        const filtered = dmcs.filter(dmc =>
            (dmc.companyName && dmc.companyName.toLowerCase().includes(lowerSearch)) ||
            (dmc.brandName && dmc.brandName.toLowerCase().includes(lowerSearch)) ||
            (dmc.destinations && dmc.destinations.toLowerCase().includes(lowerSearch)) ||
            (dmc.city && dmc.city.toLowerCase().includes(lowerSearch)) ||
            (dmc.country && dmc.country.toLowerCase().includes(lowerSearch))
        );
        setFilteredDmcs(filtered);
    };

    const toggleDmcSelection = (dmc) => {
        setSelectedDmcs(prev => {
            const exists = prev.find(d => d.companyId === dmc.companyId);
            if (exists) {
                return prev.filter(d => d.companyId !== dmc.companyId);
            } else {
                return [...prev, dmc];
            }
        });
    };

    const handleConfirmSelection = () => {
        if (selectedDmcs.length === 0) {
            toast.warning("Please select at least one DMC");
            return;
        }
        onSelectDmcs(selectedDmcs);
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered size="lg" scrollable>
            <Modal.Header closeButton className="bg-light py-2">
                <Modal.Title className="fs-14 fw-bold">
                    <i className="ri-building-line me-2 text-primary"></i>
                    Select DMC Partners
                    {selectedDmcs.length > 0 && (
                        <Badge bg="primary" className="ms-2">
                            {selectedDmcs.length} selected
                        </Badge>
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-3" style={{ maxHeight: '70vh' }}>
                <div className="mb-3">
                    <InputGroup size="sm">
                        <InputGroup.Text className="bg-white border-end-0">
                            <i className="ri-search-line text-muted"></i>
                        </InputGroup.Text>
                        <Form.Control
                            size="sm"
                            placeholder="Search DMCs..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="border-start-0 shadow-none"
                        />
                    </InputGroup>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-2">
                    <small className="text-muted">
                        {filteredDmcs.length} DMC{filteredDmcs.length !== 1 ? 's' : ''} found
                    </small>
                    {selectedDmcs.length > 0 && (
                        <Button 
                            variant="link" 
                            size="sm" 
                            className="text-danger p-0"
                            onClick={() => setSelectedDmcs([])}
                        >
                            Clear all
                        </Button>
                    )}
                </div>

                {isLoading ? (
                    <div className="text-center py-4">
                        <Spinner animation="border" variant="primary" size="sm" />
                        <p className="mt-2 text-muted small">Loading DMCs...</p>
                    </div>
                ) : filteredDmcs.length === 0 ? (
                    <div className="text-center py-4">
                        <i className="ri-building-4-line fs-36 text-muted"></i>
                        <p className="mt-2 text-muted small">No DMCs found</p>
                    </div>
                ) : (
                    <Row className="g-2">
                        {filteredDmcs.map((dmc) => {
                            const isSelected = selectedDmcs.some(d => d.companyId === dmc.companyId);
                            const destinations = dmc.destinations ? dmc.destinations.split(', ') : [];

                            return (
                                <Col xs={12} sm={6} md={4} key={dmc.companyId}>
                                    <Card
                                        className={`shadow-sm border-2 ${isSelected ? 'border-primary bg-light' : 'border-light'}`}
                                        style={{
                                            cursor: 'pointer',
                                            transition: 'all 0.15s ease',
                                            backgroundColor: isSelected ? '#f0f7ff' : '#ffffff'
                                        }}
                                        onClick={() => toggleDmcSelection(dmc)}
                                    >
                                        <Card.Body className="p-2">
                                            <div className="d-flex align-items-start">
                                                <div
                                                    className="rounded-circle d-flex align-items-center justify-content-center me-2 flex-shrink-0"
                                                    style={{
                                                        width: '36px',
                                                        height: '36px',
                                                        backgroundColor: '#e8f0fe',
                                                        border: isSelected ? '2px solid #0d6efd' : '1px solid #dee2e6'
                                                    }}
                                                >
                                                    {dmc.logoUrl ? (
                                                        <img
                                                            src={dmc.logoUrl}
                                                            alt={dmc.companyName}
                                                            style={{ width: '30px', height: '30px', objectFit: 'contain', borderRadius: '50%' }}
                                                        />
                                                    ) : (
                                                        <span className="fw-bold fs-14 text-primary">
                                                            {dmc.companyName?.charAt(0) || 'D'}
                                                        </span>
                                                    )}
                                                </div>

                                                <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                                    <div className="d-flex justify-content-between align-items-start">
                                                        <div>
                                                            <h6 className="fw-bold mb-0 text-dark" style={{ fontSize: '12px' }}>
                                                                {dmc.companyName}
                                                            </h6>
                                                            {dmc.brandName && (
                                                                <small className="text-muted" style={{ fontSize: '10px' }}>{dmc.brandName}</small>
                                                            )}
                                                        </div>
                                                        {isSelected && (
                                                            <Badge bg="primary" className="ms-1" style={{ fontSize: '8px', padding: '2px 5px' }}>
                                                                <i className="ri-check-line"></i>
                                                            </Badge>
                                                        )}
                                                    </div>

                                                    <div className="mt-1">
                                                        <small className="text-muted d-block" style={{ fontSize: '10px' }}>
                                                            <i className="ri-map-pin-line me-1 text-danger"></i>
                                                            {dmc.city || 'N/A'}, {dmc.country || 'N/A'}
                                                        </small>
                                                    </div>

                                                    {destinations.length > 0 && destinations[0] !== "MAIN" && (
                                                        <div className="mt-1">
                                                            <div className="d-flex flex-wrap gap-1">
                                                                {destinations.slice(0, 2).map((dest, idx) => (
                                                                    <Badge key={idx} bg="light" text="dark" className="border" style={{ fontSize: '8px', padding: '1px 5px' }}>
                                                                        {dest}
                                                                    </Badge>
                                                                ))}
                                                                {destinations.length > 2 && (
                                                                    <Badge bg="light" text="dark" className="border" style={{ fontSize: '8px', padding: '1px 5px' }}>
                                                                        +{destinations.length - 2}
                                                                    </Badge>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                )}
            </Modal.Body>
            <Modal.Footer className="bg-light py-2">
                <Button variant="secondary" size="sm" onClick={onHide}>
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    size="sm"
                    onClick={handleConfirmSelection}
                    disabled={selectedDmcs.length === 0}
                >
                    <i className="ri-link-m me-1"></i>
                    Connect {selectedDmcs.length} DMC{selectedDmcs.length !== 1 ? 's' : ''}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

// ============================================
// HISTORY VIEW MODAL
// ============================================
const HistoryViewModal = ({ show, onHide, history }) => {
    return (
        <Modal show={show} onHide={onHide} centered scrollable size="md">
            <Modal.Header closeButton className="bg-light">
                <Modal.Title className="fs-15 fw-bold text-uppercase">Lead Interaction History</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                {history && history.length > 0 ? (
                    <div className="acitivity-timeline acitivity-main">
                        {history.map((log, index) => (
                            <div className="acitivity-item d-flex mb-3" key={index}>
                                <div className="flex-grow-1 ms-3 border-bottom pb-3">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <h6 className="mb-0 fw-bold">Status: {log.status}</h6>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <h6 className="mb-0 fw-bold">Message: {log.message}</h6>
                                        <small className="text-muted">{moment(log.createdDate).format("DD MMM, HH:mm")}</small>
                                    </div>
                                    <small className="fw-medium text-primary">
                                        <i className="ri-user-star-line me-1"></i> Updated by: {log.userName || "Unknown"}
                                    </small>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="text-center text-muted">No history logs found.</p>
                )}
            </Modal.Body>
        </Modal>
    );
};

// ============================================
// MAIN COMPONENT - Display Individual Leads with Destination
// ============================================
const PackageEnquiryList = () => {
    const { user, loading } = useAuth();
    const navigate = useNavigate();

    const [leads, setLeads] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [editData, setEditData] = useState({});
    const [isListLoading, setIsListLoading] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [showDmcModal, setShowDmcModal] = useState(false);
    
    const [activeDmcChats, setActiveDmcChats] = useState([]);
    const [activeChatId, setActiveChatId] = useState(null);
    const [activeTab, setActiveTab] = useState('details');
    
    const today = moment().format('YYYY-MM-DD');
    const [fromDate, setFromDate] = useState(today);
    const [toDate, setToDate] = useState(today);
    const [localSearch, setLocalSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("");

    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);

    const fetchDmcChatsForLead = async (leadId) => {
        try {
            const response = await apiService.get(`${config.GET_DMC_CHATS_BY_LEAD}/${leadId}`);
            if (response && response.data) {
                setActiveDmcChats(response.data);
                if (response.data.length > 0) {
                    setActiveChatId(response.data[0].chatId);
                } else {
                    setActiveChatId(null);
                }
            }
        } catch (error) {
            console.error('Error fetching DMC chats:', error);
            setActiveDmcChats([]);
            setActiveChatId(null);
        }
    };

    const refreshDmcChats = async () => {
        if (selectedItem) {
            await fetchDmcChatsForLead(selectedItem.leadId);
        }
    };

    // Get destination from lead
    const getLeadDestination = (lead) => {
        const serviceDetails = lead.serviceDetails || {};
        
        let destination = serviceDetails.destination || 
                         serviceDetails.Destination || 
                         serviceDetails.packageDestination || 
                         serviceDetails.PackageDestination || 
                         serviceDetails.destinations ||
                         serviceDetails.Destinations ||
                         'Other';
        
        if (destination === 'Other' || !destination || destination.trim() === '') {
            const packageName = serviceDetails.packageName || serviceDetails.PackageName || '';
            if (packageName) {
                const match = packageName.match(/^([A-Za-z\s]+)/);
                if (match && match[1]) {
                    destination = match[1].trim();
                }
            }
            if (!destination || destination === 'Other') {
                destination = 'Uncategorized';
            }
        }
        
        return destination.trim();
    };

    // Get color for destination
    const getDestinationColor = (name) => {
        const colors = ['#405189', '#0ab39c', '#f7b84b', '#f06548', '#6f42c1', '#0dcaf0', '#d63384', '#198754', '#fd7e14', '#20c997'];
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        return colors[Math.abs(hash) % colors.length];
    };

    // Fetch all leads
    const GetLeads = async (pageNum = 1) => {
        if (!user) return;

        setIsListLoading(true);
        let resourceUrl = `${config.GETLEADSBYUSER}/${user.id}?PageNumber=${pageNum}&PageSize=${pageSize}&enquiryType=PACKAGE`;

        if (localSearch) resourceUrl += `&search=${encodeURIComponent(localSearch)}`;
        if (fromDate) resourceUrl += `&fromDate=${fromDate}`;
        if (toDate) resourceUrl += `&toDate=${toDate}`;
        if (statusFilter) resourceUrl += `&status=${encodeURIComponent(statusFilter)}`;

        try {
            const res = await apiService.getAll(resourceUrl);
            if (res && res.data.data) {
                const filteredData = res.data.data.filter(lead => 
                    lead.leadStatus?.toUpperCase() !== "CONVERTED TO DEAL"
                );
                setLeads(filteredData);
                setPageNumber(res.pageNumber || 1);
                setPageSize(res.pageSize || 20);
                setTotalPages(res.totalPages || 0);
                setTotalRecords(res.totalRecords || filteredData.length);
                
                // Auto-select first lead if available and no selection
                if (filteredData.length > 0 && !selectedItem) {
                    handleSelectItem(filteredData[0]);
                }
            } else {
                setLeads([]);
                setTotalRecords(0);
                setTotalPages(0);
            }
        } catch (error) {
            console.error("Error fetching leads:", error);
            setLeads([]);
            setTotalRecords(0);
            setTotalPages(0);
        } finally {
            setIsListLoading(false);
        }
    };

    useEffect(() => {
        if (user && !loading) {
            GetLeads(1);
        }
    }, [user, loading]);

    useEffect(() => {
        if (pageNumber > 0 && user) {
            GetLeads(pageNumber);
        }
    }, [pageNumber]);

    const handleSelectItem = async (item) => {
        setSelectedItem(item);
        setEditData(item ? { ...item } : {});
        setActiveTab('details');
        if (item) {
            await fetchDmcChatsForLead(item.leadId);
        } else {
            setActiveDmcChats([]);
            setActiveChatId(null);
        }
    };

    const handleLocalChange = (field, value) => {
        setEditData(prev => ({ ...prev, [field]: value }));
    };

    const updateLeadStatus = async () => {
        if (!selectedItem) return;

        const payload = {
            leadId: selectedItem.leadId,
            leadStatus: editData.leadStatus,
            callBack: editData.callBack || null,
            newLog: {
                userId: user.id,
                userName: user.name,
                status: editData.leadStatus,
                message: editData.comment || "Status updated"
            }
        };

        try {
            const res = await apiService.update(config.UPDATE_LEAD_STATUS, payload);

            if (res) {
                setEditData(prev => ({ ...prev, comment: "" }));
                await GetLeads(pageNumber);

                const updatedHistoryEntry = {
                    ...payload.newLog,
                    createdDate: new Date().toISOString()
                };

                setSelectedItem(prev => ({
                    ...prev,
                    leadStatus: editData.leadStatus,
                    callBack: editData.callBack || null,
                    history: prev.history ? [...prev.history, updatedHistoryEntry] : [updatedHistoryEntry]
                }));
                toast.success("Lead status updated successfully!");
            }
        } catch (error) {
            console.error("Update error:", error);
            toast.error("Failed to update status");
        }
    };

    const getItemId = (item) => item.leadId;
    const getItemStatus = (item) => item.leadStatus || 'NEW';
    const getItemEmail = (item) => item.email || '--';
    const getItemPhone = (item) => item.phoneNumber || '--';
    const getItemCreatedDate = (item) => item.createdDate;
    const getItemUpdatedDate = (item) => item.updatedDate;
    const getItemServiceDetails = (item) => item.serviceDetails || {};
    const getItemDescription = (item) => item.description || "No specific customer requirements.";

    const getSourceIcon = (source) => {
        const s = source?.toLowerCase() || "";
        if (s.includes("facebook")) return { icon: "ri-facebook-fill", bg: "#e8f1f9", color: "#1877f2" };
        if (s.includes("whatsapp")) return { icon: "ri-whatsapp-line", bg: "#e6fffa", color: "#25d366" };
        if (s.includes("website")) return { icon: "ri-global-line", bg: "#e0f2ff", color: "#00a3ff" };
        if (s.includes("phone")) return { icon: "ri-phone-line", bg: "#e8f5e9", color: "#4caf50" };
        return { icon: "ri-user-line", bg: "#f3f4f6", color: "#6b7280" };
    };

    const handleDmcSelection = async (selectedDmcs) => {
        try {
            setIsListLoading(true);
            
            const dmcIds = selectedDmcs.map(d => d.companyId);
            const dmcNames = selectedDmcs.map(d => d.companyName);
            
            const formData = new FormData();
            formData.append('leadId', selectedItem.leadId);
            formData.append('dmcCompanyIds', dmcIds.join(','));
            formData.append('dmcCompanyNames', dmcNames.join(','));
            
            const response = await apiService.post(config.CREATE_MULTIPLE_DMC_CHATS, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            
            if (response && response.success) {
                const createdCount = response.data.totalCreated;
                toast.success(`Connected to ${createdCount} DMC${createdCount > 1 ? 's' : ''} successfully!`);
                
                await fetchDmcChatsForLead(selectedItem.leadId);
                
                if (response.data.createdChats && response.data.createdChats.length > 0) {
                    setActiveChatId(response.data.createdChats[0].chatId);
                    setActiveTab('chat');
                }
            } else {
                toast.error("Failed to connect DMCs. Please try again.");
            }
        } catch (error) {
            console.error("Error connecting DMCs:", error);
            toast.error("Failed to connect DMCs. Please try again.");
        } finally {
            setIsListLoading(false);
            setShowDmcModal(false);
        }
    };

    const renderPagination = () => {
        if (totalPages <= 1) return null;

        const pageNumbers = [];
        const maxVisiblePages = 5;

        let startPage = Math.max(1, pageNumber - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        if (endPage - startPage + 1 < maxVisiblePages) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }

        return (
            <ul className="pagination pagination-separated pagination-sm mb-0">
                <li className={`page-item ${pageNumber === 1 ? "disabled" : ""}`} onClick={() => pageNumber > 1 && setPageNumber(pageNumber - 1)}>
                    <Link to="#" className="page-link">Previous</Link>
                </li>
                {startPage > 1 && (
                    <>
                        <li className="page-item" onClick={() => setPageNumber(1)}><Link to="#" className="page-link">1</Link></li>
                        {startPage > 2 && <li className="page-item disabled"><span className="page-link">...</span></li>}
                    </>
                )}
                {pageNumbers.map((number) => (
                    <li className={`page-item ${pageNumber === number ? "active" : ""}`} key={number} onClick={() => setPageNumber(number)}>
                        <Link to="#" className="page-link">{number}</Link>
                    </li>
                ))}
                {endPage < totalPages && (
                    <>
                        {endPage < totalPages - 1 && <li className="page-item disabled"><span className="page-link">...</span></li>}
                        <li className="page-item" onClick={() => setPageNumber(totalPages)}><Link to="#" className="page-link">{totalPages}</Link></li>
                    </>
                )}
                <li className={`page-item ${pageNumber === totalPages ? "disabled" : ""}`} onClick={() => pageNumber < totalPages && setPageNumber(pageNumber + 1)}>
                    <Link to="#" className="page-link">Next</Link>
                </li>
            </ul>
        );
    };

    const handleSearch = () => {
        setPageNumber(1);
        GetLeads(1);
    };

    const handleReset = () => {
        const todayDate = moment().format('YYYY-MM-DD');
        setFromDate(todayDate);
        setToDate(todayDate);
        setLocalSearch("");
        setStatusFilter("");
        setPageNumber(1);
        setTimeout(() => GetLeads(1), 100);
    };

    const handleStatusFilterChange = (e) => setStatusFilter(e.target.value);
    const isFollowUpStatus = editData.leadStatus?.toUpperCase() === "FOLLOW UP";

    if (loading) return <div className="p-5 text-center">Loading Dashboard...</div>;

    return (
        <div id="layout-wrapper" style={styles.pageBg}>
            <Header User={user} activeSection="packages" />
            <HistoryViewModal show={showHistoryModal} onHide={() => setShowHistoryModal(false)} history={selectedItem?.history} />
            <DmcSelectionModal show={showDmcModal} onHide={() => setShowDmcModal(false)} onSelectDmcs={handleDmcSelection} />
            
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row mt-3 g-0 shadow-lg rounded-4 overflow-hidden border border-light" style={{ height: '82vh', backgroundColor: "#fff" }}>

                            {/* LEFT SIDEBAR - Individual Leads with Destination */}
                            <div className="col-lg-3 border-end d-flex flex-column h-100" style={{ backgroundColor: "#fcfcfc", overflow: 'hidden' }}>
                                <div className="p-3 bg-white border-bottom" style={{ flexShrink: 0 }}>
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h6 className="fw-bold text-dark mb-0">Package Leads</h6>
                                        <Badge bg="primary">{leads.length}</Badge>
                                    </div>

                                    <Row className="g-2 mb-2">
                                        <Col xs={6}>
                                            <Form.Label className="small text-muted mb-0" style={{ fontSize: '9px' }}>FROM</Form.Label>
                                            <Form.Control type="date" size="sm" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                                        </Col>
                                        <Col xs={6}>
                                            <Form.Label className="small text-muted mb-0" style={{ fontSize: '9px' }}>TO</Form.Label>
                                            <Form.Control type="date" size="sm" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                                        </Col>
                                    </Row>

                                    <div className="mb-2">
                                        <Form.Label className="small text-muted mb-0" style={{ fontSize: '9px' }}>STATUS</Form.Label>
                                        <Form.Select size="sm" value={statusFilter} onChange={handleStatusFilterChange}>
                                            <option value="">All Status</option>
                                            {leadStatusOptions.map((status) => (
                                                <option key={status} value={status}>{status}</option>
                                            ))}
                                        </Form.Select>
                                    </div>

                                    <InputGroup size="sm" className="mb-2">
                                        <Form.Control
                                            className="bg-light border-end-0 shadow-none"
                                            placeholder="Search by name, phone or email..."
                                            value={localSearch}
                                            onChange={(e) => setLocalSearch(e.target.value)}
                                            onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                                        />
                                    </InputGroup>

                                    <Row className="g-2">
                                        <Col xs={6}>
                                            <Button variant="primary" size="sm" className="w-100" onClick={handleSearch}>
                                                <i className="ri-search-line me-1"></i> Search
                                            </Button>
                                        </Col>
                                        <Col xs={6}>
                                            <Button variant="danger" size="sm" className="w-100" onClick={handleReset}>
                                                <i className="ri-refresh-line me-1"></i> Reset
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>

                                <div className="flex-grow-1 overflow-auto p-2 custom-scrollbar" style={{ overflowY: 'auto' }}>
                                    {isListLoading ? (
                                        <div className="d-flex flex-column align-items-center justify-content-center h-50">
                                            <Spinner animation="border" variant="primary" />
                                            <p className="mt-2 text-muted small">Loading leads...</p>
                                        </div>
                                    ) : leads.length === 0 ? (
                                        <div className="text-center mt-5">
                                            <i className="ri-inbox-line fs-48 text-muted mb-3"></i>
                                            <p className="text-muted">No package leads found.</p>
                                        </div>
                                    ) : (
                                        leads.map((item) => {
                                            const itemId = getItemId(item);
                                            const isActive = selectedItem && getItemId(selectedItem) === itemId;
                                            const src = getSourceIcon(item.sourceName);
                                            const status = getItemStatus(item);
                                            const statusColor = getStatusColor(status);
                                            const destination = getLeadDestination(item);
                                            const destColor = getDestinationColor(destination);

                                            return (
                                                <div
                                                    key={itemId}
                                                    onClick={() => handleSelectItem(item)}
                                                    className="p-3 mb-2 cursor-pointer position-relative"
                                                    style={{
                                                        marginBottom: "12px",
                                                        borderRadius: "8px",
                                                        transition: "all 0.2s ease",
                                                        background: isActive ? "linear-gradient(to right, #eef4ff, #ffffff)" : "#fff",
                                                        borderTop: isActive ? "1px solid #b7cced" : "1px solid #e9ebec",
                                                        borderRight: isActive ? "1px solid #b7cced" : "1px solid #e9ebec",
                                                        borderBottom: isActive ? "1px solid #b7cced" : "1px solid #e9ebec",
                                                        borderLeft: `4px solid ${isActive ? "#405189" : statusColor}`,
                                                        boxShadow: isActive ? "0 4px 6px rgba(0,0,0,0.05)" : "none",
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    <div className="d-flex">
                                                        <div className="d-flex flex-column align-items-center me-3" style={{ minWidth: '50px' }}>
                                                            <div className="avatar-sm rounded-circle d-flex align-items-center justify-content-center mb-1" style={{ backgroundColor: src.bg, color: src.color }}>
                                                                <i className={`${src.icon} fs-20`}></i>
                                                            </div>
                                                            <small className="text-muted text-center fw-bold" style={{ fontSize: '9px', lineHeight: '1.1' }}>{item.sourceName || "Manual"}</small>
                                                        </div>
                                                        <div className="flex-grow-1 overflow-hidden">
                                                            <div className="d-flex justify-content-between align-items-start mb-1">
                                                                <h6 className="mb-0 text-truncate fw-bold text-dark" style={{ fontSize: '14px', maxWidth: '55%' }} title={item.name}>
                                                                    {item.name || 'Unknown'}
                                                                </h6>
                                                                <span className={`${getLeadStatusBadge(status)}`} style={{ fontSize: '9px' }}>{status}</span>
                                                            </div>
                                                            
                                                            {/* Destination Badge */}
                                                            {/* <div className="mb-1">
                                                                <Badge 
                                                                    style={{ 
                                                                        backgroundColor: `${destColor}20`, 
                                                                        color: destColor,
                                                                        fontSize: '8px',
                                                                        padding: '2px 8px',
                                                                        border: `1px solid ${destColor}40`
                                                                    }}
                                                                >
                                                                    <i className="ri-map-pin-line me-1"></i>
                                                                    {destination}
                                                                </Badge>
                                                            </div>
                                                             */}
                                                             <div className="mb-1">
    <Badge 
        style={{ 
            fontSize: '8px',
            padding: '2px 8px',
            fontWeight: 'bold'
        }}
    >
        <i className="ri-map-pin-line me-1"></i>
        {destination}
    </Badge>
</div>
                                                            {/* <div className="mb-2">
                                                                <div className="d-flex align-items-center text-black small mb-1" title={item.email}>
                                                                    <i className="ri-mail-line me-2 text-primary"></i>
                                                                    <span className="text-truncate">{item.email || "--"}</span>
                                                                </div>
                                                                <div className="d-flex align-items-center text-black small" title={item.phoneNumber}>
                                                                    <i className="ri-phone-line me-2 text-success"></i>
                                                                    <span className="text-truncate">{item.phoneNumber || "--"}</span>
                                                                </div>
                                                            </div> */}
                                                            <div className="d-flex justify-content-between border-top pt-2 mt-1">
                                                                <small className="text-black" style={{ fontSize: '10px' }}>Cr: <span className="fw-bold">{moment(getItemCreatedDate(item)).format("DD MMM HH:mm")}</span></small>
                                                                <small className="text-black" style={{ fontSize: '10px' }}>Upd: <span className="fw-bold">{moment(getItemUpdatedDate(item)).format("DD MMM HH:mm")}</span></small>
                                                            </div>
                                                            {item.dmcConnected && (
                                                                <div className="mt-1">
                                                                    <Badge bg="info" className="p-1" style={{ fontSize: '8px' }}>
                                                                        <i className="ri-chat-3-line me-1"></i> Chat Active
                                                                    </Badge>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    )}
                                </div>

                                {leads.length > 0 && totalPages > 1 && (
                                    <div className="p-2 border-top bg-white" style={{ flexShrink: 0 }}>
                                        <div className="d-flex justify-content-center">{renderPagination()}</div>
                                    </div>
                                )}
                            </div>

                            {/* RIGHT WORKSPACE - Lead Details */}
                            <div className="col-lg-9 d-flex flex-column h-100" style={{ backgroundColor: "#f8f9fa", overflow: 'hidden' }}>
                                {selectedItem ? (
                                    <>
                                        {/* Header */}
                                        <div className="p-3 shadow-sm d-flex justify-content-between align-items-center bg-white border-bottom" style={{ ...styles.summaryStrip, flexShrink: 0 }}>
                                            <div className="d-flex align-items-center">
                                                <div className="avatar-md rounded-circle d-flex align-items-center justify-content-center me-3 fw-bold fs-20 shadow-lg" style={{ background: "linear-gradient(135deg, #405189 0%, #0ab39c 100%)", color: "#fff" }}>
                                                    {selectedItem.name?.charAt(0) || '?'}
                                                </div>
                                                <div>
                                                    <h5 className="fw-bold mb-0 text-dark">{selectedItem.name || 'Unknown'}</h5>
                                                    <div className="d-flex align-items-center text-muted small">
                                                        <i className="ri-phone-line me-1 text-success"></i> {getItemPhone(selectedItem)}
                                                        <span className="mx-2 text-muted">|</span>
                                                        <i className="ri-mail-line me-1 text-primary"></i> {getItemEmail(selectedItem)}
                                                        <span className="mx-2 text-muted">|</span>
                                                        <i className="ri-calendar-line me-1 text-info"></i> {moment(getItemCreatedDate(selectedItem)).format("DD MMM YYYY")}
                                                    </div>
                                                    <div className="mt-1">
                                                        <Badge style={{ backgroundColor: `${getDestinationColor(getLeadDestination(selectedItem))}20`, color: getDestinationColor(getLeadDestination(selectedItem)) }}>
                                                            <i className="ri-map-pin-line me-1"></i>
                                                            {getLeadDestination(selectedItem)}
                                                        </Badge>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex gap-2">
                                                <Button variant="success" size="sm" className="rounded-pill px-3 fw-bold" onClick={() => window.open(`https://web.whatsapp.com/send?phone=${selectedItem.phoneNumber}`)}>
                                                    <i className="ri-whatsapp-line me-1"></i> WhatsApp
                                                </Button>
                                                <Button variant="primary" size="sm" className="rounded-pill px-3 fw-bold" onClick={() => window.location.href = `mailto:${selectedItem.email}`}>
                                                    <i className="ri-mail-line me-1"></i> Email
                                                </Button>
                                                <Button variant="primary" size="sm" className="shadow-sm" onClick={() => navigate('/createpackage', { state: { leadId: selectedItem.leadId } })}>
                                                    <i className="ri-add-line"></i> Create Package
                                                </Button>
                                                <Button variant="info" size="sm" className="shadow-sm text-white fw-bold" onClick={() => setShowDmcModal(true)}>
                                                    <i className="ri-link-m me-1"></i> Connect DMC
                                                </Button>
                                            </div>
                                        </div>

                                        {/* Tabs */}
                                        <div className="flex-grow-1 overflow-hidden" style={{ display: 'flex', flexDirection: 'column' }}>
                                            <Tabs 
                                                activeKey={activeTab} 
                                                onSelect={(k) => setActiveTab(k)}
                                                className="border-bottom bg-white" 
                                                style={{ flexShrink: 0 }}
                                            >
                                                <Tab eventKey="details" title="Enquiry Details">
                                                    <div className="p-3 overflow-auto" style={{ height: '58vh' }}>
                                                        <Row className="gy-3">
                                                            <Col md={9}>
                                                                <Card className="border-0 shadow-sm rounded-3 overflow-hidden">
                                                                    <Card.Body className="p-0">
                                                                        <div className="p-4 bg-white">
                                                                            <h6 className="fw-bold text-dark mb-3 text-uppercase small ls-1">Detailed Requirements</h6>
                                                                            <div className="border rounded overflow-hidden">
                                                                                <Row className="g-0">
                                                                                    {Object.entries(getItemServiceDetails(selectedItem) || {}).map(([key, value], index) => {
                                                                                        const displayKey = key.replace(/([A-Z])/g, ' $1').trim();
                                                                                        const isBoolean = value?.toString().toLowerCase() === "true" || value?.toString().toLowerCase() === "false";
                                                                                        const isPositive = value?.toString().toLowerCase() === "true";

                                                                                        return (
                                                                                            <Col xs={6} md={3} key={key} className={`p-3 border-bottom ${index % 4 !== 3 ? 'border-end' : ''}`} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#fcfcfc' }}>
                                                                                                <div style={styles.gridLabel}>{displayKey}</div>
                                                                                                {isBoolean ? (
                                                                                                    <Badge bg={isPositive ? "success" : "light"} className={`mt-1 ${isPositive ? "" : "text-muted border"}`}>
                                                                                                        {isPositive ? "YES" : "NO"}
                                                                                                    </Badge>
                                                                                                ) : (
                                                                                                    <div style={styles.gridValue} className="mt-1 text-truncate" title={value?.toString()}>{value?.toString() || "-"}</div>
                                                                                                )}
                                                                                            </Col>
                                                                                        );
                                                                                    })}
                                                                                    {Object.keys(getItemServiceDetails(selectedItem) || {}).length === 0 && (
                                                                                        <Col xs={12} className="p-3 text-center text-muted">No additional details available</Col>
                                                                                    )}
                                                                                </Row>
                                                                                <div className="px-4 py-3 bg-white border-bottom">
                                                                                    <div className="d-flex">
                                                                                        <i className="ri-double-quotes-l text-primary fs-20 me-2 opacity-50"></i>
                                                                                        <p className="mb-0 text-black fst-bold">{getItemDescription(selectedItem)}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Card.Body>
                                                                </Card>
                                                            </Col>

                                                            <Col md={3}>
                                                                <Card className="shadow-none border rounded-3">
                                                                    <Card.Header className="bg-light py-2 d-flex justify-content-between align-items-center">
                                                                        <h6 className="mb-0 fw-bold small text-primary">STATUS CONTROL</h6>
                                                                        <Link to="#" onClick={() => setShowHistoryModal(true)} title="View Audit Trail">
                                                                            <i className="ri-history-line fs-16 text-muted">View History</i>
                                                                        </Link>
                                                                    </Card.Header>
                                                                    <Card.Body className="p-3">
                                                                        <Form.Group className="mb-2">
                                                                            <Form.Label className="text-muted small fw-bold">STATUS</Form.Label>
                                                                            <Form.Select size="sm" value={editData.leadStatus || ""} onChange={e => handleLocalChange('leadStatus', e.target.value)}>
                                                                                <option value="NEW">NEW</option>
                                                                                <option value="PROCESSING">PROCESSING</option>
                                                                                <option value="FOLLOW UP">FOLLOW UP</option>
                                                                                <option value="REPLIED">REPLIED</option>
                                                                                <option value="NOT RESPONDING">NOT RESPONDING</option>
                                                                                <option value="NOT WORKING">NOT WORKING</option>
                                                                                <option value="CLOSED">CLOSED</option>
                                                                                <option value="WON">WON</option>
                                                                                <option value="LOST">LOST</option>
                                                                            </Form.Select>
                                                                        </Form.Group>
                                                                        
                                                                        {isFollowUpStatus && (
                                                                            <Form.Group className="mb-2">
                                                                                <Form.Label className="text-muted small fw-bold">NEXT CALL</Form.Label>
                                                                                <Form.Control size="sm" type="datetime-local" value={editData.callBack ? moment(editData.callBack).format("YYYY-MM-DDTHH:mm") : ""} onChange={e => handleLocalChange('callBack', e.target.value)} />
                                                                            </Form.Group>
                                                                        )}

                                                                        <Form.Group className="mb-2">
                                                                            <Form.Label className="text-muted small fw-bold">NOTE / COMMENT</Form.Label>
                                                                            <Form.Control as="textarea" rows={2} size="sm" placeholder="Type status update..." value={editData.comment || ""} onChange={e => handleLocalChange('comment', e.target.value)} />
                                                                        </Form.Group>

                                                                        <Button variant="primary" size="sm" className="w-100 fw-bold mt-2" onClick={updateLeadStatus}>
                                                                            Update Status
                                                                        </Button>
                                                                    </Card.Body>
                                                                </Card>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Tab>

                                                <Tab eventKey="chat" title={
                                                    <span>
                                                        <i className="ri-chat-3-line me-1"></i>
                                                        Chat
                                                        {activeDmcChats.length > 0 && (
                                                            <Badge bg="info" className="ms-1" style={{ fontSize: '9px' }}>
                                                                {activeDmcChats.length}
                                                            </Badge>
                                                        )}
                                                    </span>
                                                }>
                                                    <div className="p-0" style={{ height: '58vh' }}>
                                                        {activeDmcChats.length === 0 ? (
                                                            <div className="d-flex flex-column align-items-center justify-content-center h-100 text-muted">
                                                                <i className="ri-chat-smile-3-line fs-48 mb-3"></i>
                                                                <p>No DMC chats available for this enquiry.</p>
                                                                <Button variant="info" size="sm" className="text-white" onClick={() => setShowDmcModal(true)}>
                                                                    <i className="ri-link-m me-1"></i> Connect DMC
                                                                </Button>
                                                            </div>
                                                        ) : (
                                                            <div className="d-flex h-100">
                                                                <div className="border-end" style={{ width: '250px', overflowY: 'auto', flexShrink: 0 }}>
                                                                    <div className="p-2 bg-light border-bottom">
                                                                        <small className="fw-bold text-muted">DMC Conversations</small>
                                                                    </div>
                                                                    {activeDmcChats.map((chat) => (
                                                                        <div
                                                                            key={chat.chatId}
                                                                            className={`p-2 border-bottom cursor-pointer ${activeChatId === chat.chatId ? 'bg-primary bg-opacity-10' : ''}`}
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => setActiveChatId(chat.chatId)}
                                                                        >
                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <div>
                                                                                    <small className="fw-bold d-block">{chat.dmcCompanyName}</small>
                                                                                    <small className="text-muted" style={{ fontSize: '10px' }}>
                                                                                        {chat.summary?.lastMessagePreview?.substring(0, 30) || 'No messages'}
                                                                                    </small>
                                                                                </div>
                                                                                {chat.summary?.unreadCount > 0 && (
                                                                                    <Badge bg="danger" pill>
                                                                                        {chat.summary.unreadCount}
                                                                                    </Badge>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>

                                                                <div className="flex-grow-1">
                                                                    {activeChatId ? (
                                                                        <DmcChatView 
                                                                            chatId={activeChatId} 
                                                                            leadId={selectedItem.leadId}
                                                                            onClose={() => setActiveChatId(null)}
                                                                            onMessageSent={refreshDmcChats}
                                                                        />
                                                                    ) : (
                                                                        <div className="d-flex flex-column align-items-center justify-content-center h-100 text-muted">
                                                                            <i className="ri-chat-3-line fs-48 mb-3"></i>
                                                                            <p>Select a DMC conversation to view</p>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </Tab>
                                            </Tabs>
                                        </div>
                                    </>
                                ) : (
                                    <div className="h-100 d-flex flex-column align-items-center justify-content-center">
                                        <div className="mb-3 avatar-lg bg-white rounded-circle shadow-sm d-flex align-items-center justify-content-center">
                                            <i className="ri-inbox-line fs-36 text-primary"></i>
                                        </div>
                                        <h5 className="text-dark fw-bold">Welcome to Enquiry Manager</h5>
                                        <p className="text-muted">Select a lead from the inbox to display details.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PackageEnquiryList;